!(function (t) {
    var e = {};
    function i(n) {
      if (e[n]) return e[n].exports;
      var r = (e[n] = { i: n, l: !1, exports: {} });
      return t[n].call(r.exports, r, r.exports, i), (r.l = !0), r.exports;
    }
    (i.m = t),
      (i.c = e),
      (i.d = function (t, e, n) {
        i.o(t, e) ||
          Object.defineProperty(t, e, {
            configurable: !1,
            enumerable: !0,
            get: n,
          });
      }),
      (i.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return i.d(e, "a", e), e;
      }),
      (i.o = function (t, e) { 
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (i.p = ""),
      i((i.s = 4));
  })([
    function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.paddy = function (t, e, i) {
          void 0 === i && (i = "0");
          var n = new Array(1 + e).join(i);
          return (n + t).slice(-n.length);
        }),
        (e.addClass = function (t, e) {
          -1 === t.className.indexOf(e) && (t.className += " " + e);
        }),
        (e.removeClass = function (t, e) {
          t.className = t.className.replace(e, "").trim();
        }),
        (e.isMobileBrowser = function () {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );
        }),
        (e.isMobileLayout = function () {
          return (
            -1 !== document.querySelector("#pi-stage").className.indexOf("mobile")
          );
        }),
        (e.qsForEach = function (t, e, i) {
          for (var n = 0; n < t.length; n++) e.call(i, t[n], n);
        }),
        (e.getMobileOperatingSystem = function () {
          var t = navigator.userAgent || navigator.vendor || window.opera;
          return /windows phone/i.test(t)
            ? "Windows Phone"
            : /android/i.test(t)
            ? "Android"
            : /iPad|iPhone|iPod/.test(t) && !window.MSStream
            ? "iOS"
            : "unknown";
        }),
        (e.detectIE = function () {
          var t = window.navigator.userAgent,
            e = t.indexOf("MSIE ");
          if (e > 0) return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
          if (t.indexOf("Trident/") > 0) {
            var i = t.indexOf("rv:");
            return parseInt(t.substring(i + 3, t.indexOf(".", i)), 10);
          }
          var n = t.indexOf("Edge/");
          return n > 0 && parseInt(t.substring(n + 5, t.indexOf(".", n)), 10);
        });
    },
    function (t, e, i) {
      (function (i) {
        var n,
          r,
          o,
          s = { scope: {} };
        (s.defineProperty =
          "function" == typeof Object.defineProperties
            ? Object.defineProperty
            : function (t, e, i) {
                if (i.get || i.set)
                  throw new TypeError(
                    "ES3 does not support getters and setters."
                  );
                t != Array.prototype && t != Object.prototype && (t[e] = i.value);
              }),
          (s.getGlobal = function (t) {
            return "undefined" != typeof window && window === t
              ? t
              : void 0 !== i && null != i
              ? i
              : t;
          }),
          (s.global = s.getGlobal(this)),
          (s.SYMBOL_PREFIX = "jscomp_symbol_"),
          (s.initSymbol = function () {
            (s.initSymbol = function () {}),
              s.global.Symbol || (s.global.Symbol = s.Symbol);
          }),
          (s.symbolCounter_ = 0),
          (s.Symbol = function (t) {
            return s.SYMBOL_PREFIX + (t || "") + s.symbolCounter_++;
          }),
          (s.initSymbolIterator = function () {
            s.initSymbol();
            var t = s.global.Symbol.iterator;
            t || (t = s.global.Symbol.iterator = s.global.Symbol("iterator")),
              "function" != typeof Array.prototype[t] &&
                s.defineProperty(Array.prototype, t, {
                  configurable: !0,
                  writable: !0,
                  value: function () {
                    return s.arrayIterator(this);
                  },
                }),
              (s.initSymbolIterator = function () {});
          }),
          (s.arrayIterator = function (t) {
            var e = 0;
            return s.iteratorPrototype(function () {
              return e < t.length ? { done: !1, value: t[e++] } : { done: !0 };
            });
          }),
          (s.iteratorPrototype = function (t) {
            return (
              s.initSymbolIterator(),
              ((t = { next: t })[s.global.Symbol.iterator] = function () {
                return this;
              }),
              t
            );
          }),
          (s.array = s.array || {}),
          (s.iteratorFromArray = function (t, e) {
            s.initSymbolIterator(), t instanceof String && (t += "");
            var i = 0,
              n = {
                next: function () {
                  if (i < t.length) {
                    var r = i++;
                    return { value: e(r, t[r]), done: !1 };
                  }
                  return (
                    (n.next = function () {
                      return { done: !0, value: void 0 };
                    }),
                    n.next()
                  );
                },
              };
            return (
              (n[Symbol.iterator] = function () {
                return n;
              }),
              n
            );
          }),
          (s.polyfill = function (t, e, i, n) {
            if (e) {
              for (i = s.global, t = t.split("."), n = 0; n < t.length - 1; n++) {
                var r = t[n];
                r in i || (i[r] = {}), (i = i[r]);
              }
              (e = e((n = i[(t = t[t.length - 1])]))) != n &&
                null != e &&
                s.defineProperty(i, t, {
                  configurable: !0,
                  writable: !0,
                  value: e,
                });
            }
          }),
          s.polyfill(
            "Array.prototype.keys",
            function (t) {
              return (
                t ||
                function () {
                  return s.iteratorFromArray(this, function (t) {
                    return t;
                  });
                }
              );
            },
            "es6-impl",
            "es3"
          );
        var a = this;
        (r = []),
          void 0 ===
            (o =
              "function" ==
              typeof (n = function () {
                function t(t) {
                  if (!P.col(t))
                    try {
                      return document.querySelectorAll(t);
                    } catch (t) {}
                }
                function e(t, e) {
                  for (
                    var i = t.length,
                      n = 2 <= arguments.length ? arguments[1] : void 0,
                      r = [],
                      o = 0;
                    o < i;
                    o++
                  )
                    if (o in t) {
                      var s = t[o];
                      e.call(n, s, o, t) && r.push(s);
                    }
                  return r;
                }
                function i(t) {
                  return t.reduce(function (t, e) {
                    return t.concat(P.arr(e) ? i(e) : e);
                  }, []);
                }
                function n(e) {
                  return P.arr(e)
                    ? e
                    : (P.str(e) && (e = t(e) || e),
                      e instanceof NodeList || e instanceof HTMLCollection
                        ? [].slice.call(e)
                        : [e]);
                }
                function r(t, e) {
                  return t.some(function (t) {
                    return t === e;
                  });
                }
                function o(t) {
                  var e,
                    i = {};
                  for (e in t) i[e] = t[e];
                  return i;
                }
                function s(t, e) {
                  var i,
                    n = o(t);
                  for (i in t) n[i] = e.hasOwnProperty(i) ? e[i] : t[i];
                  return n;
                }
                function u(t, e) {
                  var i,
                    n = o(t);
                  for (i in e) n[i] = P.und(t[i]) ? e[i] : t[i];
                  return n;
                }
                function c(t) {
                  if (
                    (t = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(
                      t
                    ))
                  )
                    return t[2];
                }
                function l(t, e) {
                  return P.fnc(t) ? t(e.target, e.id, e.total) : t;
                }
                function h(t, e) {
                  if (e in t.style)
                    return (
                      getComputedStyle(t).getPropertyValue(
                        e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
                      ) || "0"
                    );
                }
                function d(t, e) {
                  return P.dom(t) && r(M, e)
                    ? "transform"
                    : P.dom(t) && (t.getAttribute(e) || (P.svg(t) && t[e]))
                    ? "attribute"
                    : P.dom(t) && "transform" !== e && h(t, e)
                    ? "css"
                    : null != t[e]
                    ? "object"
                    : void 0;
                }
                function f(t, i) {
                  switch (d(t, i)) {
                    case "transform":
                      return (function (t, i) {
                        var n = (function (t) {
                          return -1 < t.indexOf("translate") ||
                            "perspective" === t
                            ? "px"
                            : -1 < t.indexOf("rotate") || -1 < t.indexOf("skew")
                            ? "deg"
                            : void 0;
                        })(i);
                        if (
                          ((n = -1 < i.indexOf("scale") ? 1 : 0 + n),
                          !(t = t.style.transform))
                        )
                          return n;
                        for (
                          var r = [], o = [], s = [], a = /(\w+)\((.+?)\)/g;
                          (r = a.exec(t));
  
                        )
                          o.push(r[1]), s.push(r[2]);
                        return (t = e(s, function (t, e) {
                          return o[e] === i;
                        })).length
                          ? t[0]
                          : n;
                      })(t, i);
                    case "css":
                      return h(t, i);
                    case "attribute":
                      return t.getAttribute(i);
                  }
                  return t[i] || 0;
                }
                function p(t, e) {
                  var i = /^(\*=|\+=|-=)/.exec(t);
                  if (!i) return t;
                  var n = c(t) || 0;
                  switch (
                    ((e = parseFloat(e)),
                    (t = parseFloat(t.replace(i[0], ""))),
                    i[0][0])
                  ) {
                    case "+":
                      return e + t + n;
                    case "-":
                      return e - t + n;
                    case "*":
                      return e * t + n;
                  }
                }
                function m(t, e) {
                  return Math.sqrt(
                    Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)
                  );
                }
                function v(t) {
                  t = t.points;
                  for (var e, i = 0, n = 0; n < t.numberOfItems; n++) {
                    var r = t.getItem(n);
                    0 < n && (i += m(e, r)), (e = r);
                  }
                  return i;
                }
                function _(t) {
                  if (t.getTotalLength) return t.getTotalLength();
                  switch (t.tagName.toLowerCase()) {
                    case "circle":
                      return 2 * Math.PI * t.getAttribute("r");
                    case "rect":
                      return (
                        2 * t.getAttribute("width") + 2 * t.getAttribute("height")
                      );
                    case "line":
                      return m(
                        { x: t.getAttribute("x1"), y: t.getAttribute("y1") },
                        { x: t.getAttribute("x2"), y: t.getAttribute("y2") }
                      );
                    case "polyline":
                      return v(t);
                    case "polygon":
                      var e = t.points;
                      return (
                        v(t) + m(e.getItem(e.numberOfItems - 1), e.getItem(0))
                      );
                  }
                }
                function g(t, e) {
                  function i(i) {
                    return (
                      (i = void 0 === i ? 0 : i),
                      t.el.getPointAtLength(1 <= e + i ? e + i : 0)
                    );
                  }
                  var n = i(),
                    r = i(-1),
                    o = i(1);
                  switch (t.property) {
                    case "x":
                      return n.x;
                    case "y":
                      return n.y;
                    case "angle":
                      return (180 * Math.atan2(o.y - r.y, o.x - r.x)) / Math.PI;
                  }
                }
                function y(t, e) {
                  var i,
                    n = /-?\d*\.?\d+/g;
                  if (((i = P.pth(t) ? t.totalLength : t), P.col(i)))
                    if (P.rgb(i)) {
                      var r = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(i);
                      i = r ? "rgba(" + r[1] + ",1)" : i;
                    } else
                      i = P.hex(i)
                        ? (function (t) {
                            t = t.replace(
                              /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
                              function (t, e, i, n) {
                                return e + e + i + i + n + n;
                              }
                            );
                            var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
                              t
                            );
                            return (
                              "rgba(" +
                              (t = parseInt(e[1], 16)) +
                              "," +
                              parseInt(e[2], 16) +
                              "," +
                              (e = parseInt(e[3], 16)) +
                              ",1)"
                            );
                          })(i)
                        : P.hsl(i)
                        ? (function (t) {
                            function e(t, e, i) {
                              return (
                                0 > i && (i += 1),
                                1 < i && --i,
                                i < 1 / 6
                                  ? t + 6 * (e - t) * i
                                  : 0.5 > i
                                  ? e
                                  : i < 2 / 3
                                  ? t + (e - t) * (2 / 3 - i) * 6
                                  : t
                              );
                            }
                            var i =
                              /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) ||
                              /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(
                                t
                              );
                            t = parseInt(i[1]) / 360;
                            var n = parseInt(i[2]) / 100,
                              r = parseInt(i[3]) / 100;
                            if (((i = i[4] || 1), 0 == n)) r = n = t = r;
                            else {
                              var o = 0.5 > r ? r * (1 + n) : r + n - r * n,
                                s = 2 * r - o;
                              (r = e(s, o, t + 1 / 3)),
                                (n = e(s, o, t)),
                                (t = e(s, o, t - 1 / 3));
                            }
                            return (
                              "rgba(" +
                              255 * r +
                              "," +
                              255 * n +
                              "," +
                              255 * t +
                              "," +
                              i +
                              ")"
                            );
                          })(i)
                        : void 0;
                  else
                    (r = (r = c(i)) ? i.substr(0, i.length - r.length) : i),
                      (i = e && !/\s/g.test(i) ? r + e : r);
                  return {
                    original: (i += ""),
                    numbers: i.match(n) ? i.match(n).map(Number) : [0],
                    strings: P.str(t) || e ? i.split(n) : [],
                  };
                }
                function b(t) {
                  return e(
                    (t = t ? i(P.arr(t) ? t.map(n) : n(t)) : []),
                    function (t, e, i) {
                      return i.indexOf(t) === e;
                    }
                  );
                }
                function w(t, e) {
                  var i = o(e);
                  if (P.arr(t)) {
                    var r = t.length;
                    2 !== r || P.obj(t[0])
                      ? P.fnc(e.duration) || (i.duration = e.duration / r)
                      : (t = { value: t });
                  }
                  return n(t)
                    .map(function (t, i) {
                      return (
                        (i = i ? 0 : e.delay),
                        (t = P.obj(t) && !P.pth(t) ? t : { value: t }),
                        P.und(t.delay) && (t.delay = i),
                        t
                      );
                    })
                    .map(function (t) {
                      return u(t, i);
                    });
                }
                function S(t, e) {
                  var i;
                  return t.tweens.map(function (n) {
                    var r = (n = (function (t, e) {
                        var i,
                          n = {};
                        for (i in t) {
                          var r = l(t[i], e);
                          P.arr(r) &&
                            1 ===
                              (r = r.map(function (t) {
                                return l(t, e);
                              })).length &&
                            (r = r[0]),
                            (n[i] = r);
                        }
                        return (
                          (n.duration = parseFloat(n.duration)),
                          (n.delay = parseFloat(n.delay)),
                          n
                        );
                      })(n, e)).value,
                      o = f(e.target, t.name),
                      s = i ? i.to.original : o,
                      a = ((s = P.arr(r) ? r[0] : s), p(P.arr(r) ? r[1] : r, s));
                    o = c(a) || c(s) || c(o);
                    return (
                      (n.from = y(s, o)),
                      (n.to = y(a, o)),
                      (n.start = i ? i.end : t.offset),
                      (n.end = n.start + n.delay + n.duration),
                      (n.easing = (function (t) {
                        return P.arr(t) ? D.apply(this, t) : C[t];
                      })(n.easing)),
                      (n.elasticity =
                        (1e3 - Math.min(Math.max(n.elasticity, 1), 999)) / 1e3),
                      (n.isPath = P.pth(r)),
                      (n.isColor = P.col(n.from.original)),
                      n.isColor && (n.round = 1),
                      (i = n)
                    );
                  });
                }
                function E(t, e, i, n) {
                  var r = "delay" === t;
                  return e.length
                    ? (r ? Math.min : Math.max).apply(
                        Math,
                        e.map(function (e) {
                          return e[t];
                        })
                      )
                    : r
                    ? n.delay
                    : i.offset + n.delay + n.duration;
                }
                function T(t) {
                  var n,
                    r = s(O, t),
                    o = s(A, t),
                    a = (function (t) {
                      var e = b(t);
                      return e.map(function (t, i) {
                        return { target: t, id: i, total: e.length };
                      });
                    })(t.targets),
                    c = [],
                    l = u(r, o);
                  for (n in t)
                    l.hasOwnProperty(n) ||
                      "targets" === n ||
                      c.push({ name: n, offset: l.offset, tweens: w(t[n], o) });
                  return (
                    (t = (function (t, n) {
                      return e(
                        i(
                          t.map(function (t) {
                            return n.map(function (e) {
                              var i = d(t.target, e.name);
                              if (i) {
                                var n = S(e, t);
                                e = {
                                  type: i,
                                  property: e.name,
                                  animatable: t,
                                  tweens: n,
                                  duration: n[n.length - 1].end,
                                  delay: n[0].delay,
                                };
                              } else e = void 0;
                              return e;
                            });
                          })
                        ),
                        function (t) {
                          return !P.und(t);
                        }
                      );
                    })(a, c)),
                    u(r, {
                      children: [],
                      animatables: a,
                      animations: t,
                      duration: E("duration", t, r, o),
                      delay: E("delay", t, r, o),
                    })
                  );
                }
                function I(t) {
                  function i() {
                    return (
                      window.Promise &&
                      new Promise(function (t) {
                        return (d = t);
                      })
                    );
                  }
                  function n(t) {
                    return p.reversed ? p.duration - t : t;
                  }
                  function r(t) {
                    for (
                      var i = 0, n = {}, r = p.animations, o = r.length;
                      i < o;
  
                    ) {
                      var s = r[i],
                        a = s.animatable,
                        u = (c = s.tweens)[(f = c.length - 1)];
                      f &&
                        (u =
                          e(c, function (e) {
                            return t < e.end;
                          })[0] || u);
                      for (
                        var c =
                            Math.min(
                              Math.max(t - u.start - u.delay, 0),
                              u.duration
                            ) / u.duration,
                          l = isNaN(c) ? 1 : u.easing(c, u.elasticity),
                          d = ((c = u.to.strings), u.round),
                          f = [],
                          m = void 0,
                          v = ((m = u.to.numbers.length), 0);
                        v < m;
                        v++
                      ) {
                        var _ = void 0,
                          y = ((_ = u.to.numbers[v]), u.from.numbers[v]);
                        _ = u.isPath ? g(u.value, l * _) : y + l * (_ - y);
                        d &&
                          ((u.isColor && 2 < v) || (_ = Math.round(_ * d) / d)),
                          f.push(_);
                      }
                      if ((u = c.length))
                        for (m = c[0], l = 0; l < u; l++)
                          (d = c[l + 1]),
                            (v = f[l]),
                            isNaN(v) || (m = d ? m + (v + d) : m + (v + " "));
                      else m = f[0];
                      L[s.type](a.target, s.property, m, n, a.id),
                        (s.currentValue = m),
                        i++;
                    }
                    if ((i = Object.keys(n).length))
                      for (r = 0; r < i; r++)
                        x ||
                          (x = h(document.body, "transform")
                            ? "transform"
                            : "-webkit-transform"),
                          (p.animatables[r].target.style[x] = n[r].join(" "));
                    (p.currentTime = t), (p.progress = (t / p.duration) * 100);
                  }
                  function o(t) {
                    p[t] && p[t](p);
                  }
                  function s() {
                    p.remaining && !0 !== p.remaining && p.remaining--;
                  }
                  function a(t) {
                    var e = p.duration,
                      a = p.offset,
                      h = a + p.delay,
                      m = p.currentTime,
                      v = p.reversed,
                      _ = n(t);
                    if (p.children.length) {
                      var g = p.children,
                        y = g.length;
                      if (_ >= p.currentTime)
                        for (var b = 0; b < y; b++) g[b].seek(_);
                      else for (; y--; ) g[y].seek(_);
                    }
                    (_ >= h || !e) &&
                      (p.began || ((p.began = !0), o("begin")), o("run")),
                      _ > a && _ < e
                        ? r(_)
                        : (_ <= a && 0 !== m && (r(0), v && s()),
                          ((_ >= e && m !== e) || !e) && (r(e), v || s())),
                      o("update"),
                      t >= e &&
                        (p.remaining
                          ? ((c = u),
                            "alternate" === p.direction &&
                              (p.reversed = !p.reversed))
                          : (p.pause(),
                            p.completed ||
                              ((p.completed = !0),
                              o("complete"),
                              "Promise" in window && (d(), (f = i())))),
                        (l = 0));
                  }
                  t = void 0 === t ? {} : t;
                  var u,
                    c,
                    l = 0,
                    d = null,
                    f = i(),
                    p = T(t);
                  return (
                    (p.reset = function () {
                      var t = p.direction,
                        e = p.loop;
                      for (
                        p.currentTime = 0,
                          p.progress = 0,
                          p.paused = !0,
                          p.began = !1,
                          p.completed = !1,
                          p.reversed = "reverse" === t,
                          p.remaining = "alternate" === t && 1 === e ? 2 : e,
                          r(0),
                          t = p.children.length;
                        t--;
  
                      )
                        p.children[t].reset();
                    }),
                    (p.tick = function (t) {
                      (u = t), c || (c = u), a((l + u - c) * I.speed);
                    }),
                    (p.seek = function (t) {
                      a(n(t));
                    }),
                    (p.pause = function () {
                      var t = q.indexOf(p);
                      -1 < t && q.splice(t, 1), (p.paused = !0);
                    }),
                    (p.play = function () {
                      p.paused &&
                        ((p.paused = !1),
                        (c = 0),
                        (l = n(p.currentTime)),
                        q.push(p),
                        k || H());
                    }),
                    (p.reverse = function () {
                      (p.reversed = !p.reversed), (c = 0), (l = n(p.currentTime));
                    }),
                    (p.restart = function () {
                      p.pause(), p.reset(), p.play();
                    }),
                    (p.finished = f),
                    p.reset(),
                    p.autoplay && p.play(),
                    p
                  );
                }
                var x,
                  O = {
                    update: void 0,
                    begin: void 0,
                    run: void 0,
                    complete: void 0,
                    loop: 1,
                    direction: "normal",
                    autoplay: !0,
                    offset: 0,
                  },
                  A = {
                    duration: 1e3,
                    delay: 0,
                    easing: "easeOutElastic",
                    elasticity: 500,
                    round: 0,
                  },
                  M = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(
                    " "
                  ),
                  P = {
                    arr: function (t) {
                      return Array.isArray(t);
                    },
                    obj: function (t) {
                      return (
                        -1 < Object.prototype.toString.call(t).indexOf("Object")
                      );
                    },
                    pth: function (t) {
                      return P.obj(t) && t.hasOwnProperty("totalLength");
                    },
                    svg: function (t) {
                      return t instanceof SVGElement;
                    },
                    dom: function (t) {
                      return t.nodeType || P.svg(t);
                    },
                    str: function (t) {
                      return "string" == typeof t;
                    },
                    fnc: function (t) {
                      return "function" == typeof t;
                    },
                    und: function (t) {
                      return void 0 === t;
                    },
                    hex: function (t) {
                      return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
                    },
                    rgb: function (t) {
                      return /^rgb/.test(t);
                    },
                    hsl: function (t) {
                      return /^hsl/.test(t);
                    },
                    col: function (t) {
                      return P.hex(t) || P.rgb(t) || P.hsl(t);
                    },
                  },
                  D = (function () {
                    function t(t, e, i) {
                      return (
                        (((1 - 3 * i + 3 * e) * t + (3 * i - 6 * e)) * t +
                          3 * e) *
                        t
                      );
                    }
                    return function (e, i, n, r) {
                      if (0 <= e && 1 >= e && 0 <= n && 1 >= n) {
                        var o = new Float32Array(11);
                        if (e !== i || n !== r)
                          for (var s = 0; 11 > s; ++s) o[s] = t(0.1 * s, e, n);
                        return function (s) {
                          if (e === i && n === r) return s;
                          if (0 === s) return 0;
                          if (1 === s) return 1;
                          for (var a = 0, u = 1; 10 !== u && o[u] <= s; ++u)
                            a += 0.1;
                          u = a + ((s - o[--u]) / (o[u + 1] - o[u])) * 0.1;
                          var c =
                            3 * (1 - 3 * n + 3 * e) * u * u +
                            2 * (3 * n - 6 * e) * u +
                            3 * e;
                          if (0.001 <= c) {
                            for (
                              a = 0;
                              4 > a &&
                              0 !==
                                (c =
                                  3 * (1 - 3 * n + 3 * e) * u * u +
                                  2 * (3 * n - 6 * e) * u +
                                  3 * e);
                              ++a
                            ) {
                              var l = t(u, e, n) - s;
                              u = u - l / c;
                            }
                            s = u;
                          } else if (0 === c) s = u;
                          else {
                            (u = a), (a = a + 0.1);
                            var h = 0;
                            do {
                              0 < (c = t((l = u + (a - u) / 2), e, n) - s)
                                ? (a = l)
                                : (u = l);
                            } while (1e-7 < Math.abs(c) && 10 > ++h);
                            s = l;
                          }
                          return t(s, i, r);
                        };
                      }
                    };
                  })(),
                  C = (function () {
                    function t(t, e) {
                      return 0 === t || 1 === t
                        ? t
                        : -Math.pow(2, 10 * (t - 1)) *
                            Math.sin(
                              (2 *
                                (t - 1 - (e / (2 * Math.PI)) * Math.asin(1)) *
                                Math.PI) /
                                e
                            );
                    }
                    var e,
                      i = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(
                        " "
                      ),
                      n = {
                        In: [
                          [0.55, 0.085, 0.68, 0.53],
                          [0.55, 0.055, 0.675, 0.19],
                          [0.895, 0.03, 0.685, 0.22],
                          [0.755, 0.05, 0.855, 0.06],
                          [0.47, 0, 0.745, 0.715],
                          [0.95, 0.05, 0.795, 0.035],
                          [0.6, 0.04, 0.98, 0.335],
                          [0.6, -0.28, 0.735, 0.045],
                          t,
                        ],
                        Out: [
                          [0.25, 0.46, 0.45, 0.94],
                          [0.215, 0.61, 0.355, 1],
                          [0.165, 0.84, 0.44, 1],
                          [0.23, 1, 0.32, 1],
                          [0.39, 0.575, 0.565, 1],
                          [0.19, 1, 0.22, 1],
                          [0.075, 0.82, 0.165, 1],
                          [0.175, 0.885, 0.32, 1.275],
                          function (e, i) {
                            return 1 - t(1 - e, i);
                          },
                        ],
                        InOut: [
                          [0.455, 0.03, 0.515, 0.955],
                          [0.645, 0.045, 0.355, 1],
                          [0.77, 0, 0.175, 1],
                          [0.86, 0, 0.07, 1],
                          [0.445, 0.05, 0.55, 0.95],
                          [1, 0, 0, 1],
                          [0.785, 0.135, 0.15, 0.86],
                          [0.68, -0.55, 0.265, 1.55],
                          function (e, i) {
                            return 0.5 > e
                              ? t(2 * e, i) / 2
                              : 1 - t(-2 * e + 2, i) / 2;
                          },
                        ],
                      },
                      r = { linear: D(0.25, 0.25, 0.75, 0.75) },
                      o = {};
                    for (e in n)
                      (o.type = e),
                        n[o.type].forEach(
                          (function (t) {
                            return function (e, n) {
                              r["ease" + t.type + i[n]] = P.fnc(e)
                                ? e
                                : D.apply(a, e);
                            };
                          })(o)
                        ),
                        (o = { type: o.type });
                    return r;
                  })(),
                  L = {
                    css: function (t, e, i) {
                      return (t.style[e] = i);
                    },
                    attribute: function (t, e, i) {
                      return t.setAttribute(e, i);
                    },
                    object: function (t, e, i) {
                      return (t[e] = i);
                    },
                    transform: function (t, e, i, n, r) {
                      n[r] || (n[r] = []), n[r].push(e + "(" + i + ")");
                    },
                  },
                  q = [],
                  k = 0,
                  H = (function () {
                    function t() {
                      k = requestAnimationFrame(e);
                    }
                    function e(e) {
                      var i = q.length;
                      if (i) {
                        for (var n = 0; n < i; ) q[n] && q[n].tick(e), n++;
                        t();
                      } else cancelAnimationFrame(k), (k = 0);
                    }
                    return t;
                  })();
                return (
                  (I.version = "2.2.0"),
                  (I.speed = 1),
                  (I.running = q),
                  (I.remove = function (t) {
                    t = b(t);
                    for (var e = q.length; e--; )
                      for (var i = q[e], n = i.animations, o = n.length; o--; )
                        r(t, n[o].animatable.target) &&
                          (n.splice(o, 1), n.length || i.pause());
                  }),
                  (I.getValue = f),
                  (I.path = function (e, i) {
                    var n = P.str(e) ? t(e)[0] : e,
                      r = i || 100;
                    return function (t) {
                      return {
                        el: n,
                        property: t,
                        totalLength: _(n) * (r / 100),
                      };
                    };
                  }),
                  (I.setDashoffset = function (t) {
                    var e = _(t);
                    return t.setAttribute("stroke-dasharray", e), e;
                  }),
                  (I.bezier = D),
                  (I.easings = C),
                  (I.timeline = function (t) {
                    var e = I(t);
                    return (
                      e.pause(),
                      (e.duration = 0),
                      (e.add = function (i) {
                        return (
                          e.children.forEach(function (t) {
                            (t.began = !0), (t.completed = !0);
                          }),
                          n(i).forEach(function (i) {
                            var n = u(i, s(A, t || {}));
                            (n.targets = n.targets || t.targets),
                              (i = e.duration);
                            var r = n.offset;
                            (n.autoplay = !1),
                              (n.direction = e.direction),
                              (n.offset = P.und(r) ? i : p(r, i)),
                              (e.began = !0),
                              (e.completed = !0),
                              e.seek(n.offset),
                              ((n = I(n)).began = !0),
                              (n.completed = !0),
                              n.duration > i && (e.duration = n.duration),
                              e.children.push(n);
                          }),
                          e.seek(0),
                          e.reset(),
                          e.autoplay && e.restart(),
                          e
                        );
                      }),
                      e
                    );
                  }),
                  (I.random = function (t, e) {
                    return Math.floor(Math.random() * (e - t + 1)) + t;
                  }),
                  I
                );
              })
                ? n.apply(e, r)
                : n) || (t.exports = o);
      }.call(e, i(2)));
    },
    function (t, e) {
      var i;
      i = (function () {
        return this;
      })();
      try {
        i = i || Function("return this")() || (0, eval)("this");
      } catch (t) {
        "object" == typeof window && (i = window);
      }
      t.exports = i;
    },
    function (t, e) {
      function i() {
        (this._events = this._events || {}),
          (this._maxListeners = this._maxListeners || void 0);
      }
      function n(t) {
        return "function" == typeof t;
      }
      function r(t) {
        return "object" == typeof t && null !== t;
      }
      function o(t) {
        return void 0 === t;
      }
      (t.exports = i),
        (i.EventEmitter = i),
        (i.prototype._events = void 0),
        (i.prototype._maxListeners = void 0),
        (i.defaultMaxListeners = 10),
        (i.prototype.setMaxListeners = function (t) {
          if ("number" != typeof t || t < 0 || isNaN(t))
            throw TypeError("n must be a positive number");
          return (this._maxListeners = t), this;
        }),
        (i.prototype.emit = function (t) {
          var e, i, s, a, u, c;
          if (
            (this._events || (this._events = {}),
            "error" === t &&
              (!this._events.error ||
                (r(this._events.error) && !this._events.error.length)))
          ) {
            if ((e = arguments[1]) instanceof Error) throw e;
            var l = new Error('Uncaught, unspecified "error" event. (' + e + ")");
            throw ((l.context = e), l);
          }
          if (o((i = this._events[t]))) return !1;
          if (n(i))
            switch (arguments.length) {
              case 1:
                i.call(this);
                break;
              case 2:
                i.call(this, arguments[1]);
                break;
              case 3:
                i.call(this, arguments[1], arguments[2]);
                break;
              default:
                (a = Array.prototype.slice.call(arguments, 1)), i.apply(this, a);
            }
          else if (r(i))
            for (
              a = Array.prototype.slice.call(arguments, 1),
                s = (c = i.slice()).length,
                u = 0;
              u < s;
              u++
            )
              c[u].apply(this, a);
          return !0;
        }),
        (i.prototype.addListener = function (t, e) {
          var s;
          if (!n(e)) throw TypeError("listener must be a function");
          return (
            this._events || (this._events = {}),
            this._events.newListener &&
              this.emit("newListener", t, n(e.listener) ? e.listener : e),
            this._events[t]
              ? r(this._events[t])
                ? this._events[t].push(e)
                : (this._events[t] = [this._events[t], e])
              : (this._events[t] = e),
            r(this._events[t]) &&
              !this._events[t].warned &&
              (s = o(this._maxListeners)
                ? i.defaultMaxListeners
                : this._maxListeners) &&
              s > 0 &&
              this._events[t].length > s &&
              ((this._events[t].warned = !0),
              console.error(
                "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
                this._events[t].length
              ),
              "function" == typeof console.trace && console.trace()),
            this
          );
        }),
        (i.prototype.on = i.prototype.addListener),
        (i.prototype.once = function (t, e) {
          if (!n(e)) throw TypeError("listener must be a function");
          var i = !1;
          function r() {
            this.removeListener(t, r), i || ((i = !0), e.apply(this, arguments));
          }
          return (r.listener = e), this.on(t, r), this;
        }),
        (i.prototype.removeListener = function (t, e) {
          var i, o, s, a;
          if (!n(e)) throw TypeError("listener must be a function");
          if (!this._events || !this._events[t]) return this;
          if (
            ((s = (i = this._events[t]).length),
            (o = -1),
            i === e || (n(i.listener) && i.listener === e))
          )
            delete this._events[t],
              this._events.removeListener && this.emit("removeListener", t, e);
          else if (r(i)) {
            for (a = s; a-- > 0; )
              if (i[a] === e || (i[a].listener && i[a].listener === e)) {
                o = a;
                break;
              }
            if (o < 0) return this;
            1 === i.length
              ? ((i.length = 0), delete this._events[t])
              : i.splice(o, 1),
              this._events.removeListener && this.emit("removeListener", t, e);
          }
          return this;
        }),
        (i.prototype.removeAllListeners = function (t) {
          var e, i;
          if (!this._events) return this;
          if (!this._events.removeListener)
            return (
              0 === arguments.length
                ? (this._events = {})
                : this._events[t] && delete this._events[t],
              this
            );
          if (0 === arguments.length) {
            for (e in this._events)
              "removeListener" !== e && this.removeAllListeners(e);
            return (
              this.removeAllListeners("removeListener"), (this._events = {}), this
            );
          }
          if (n((i = this._events[t]))) this.removeListener(t, i);
          else if (i) for (; i.length; ) this.removeListener(t, i[i.length - 1]);
          return delete this._events[t], this;
        }),
        (i.prototype.listeners = function (t) {
          return this._events && this._events[t]
            ? n(this._events[t])
              ? [this._events[t]]
              : this._events[t].slice()
            : [];
        }),
        (i.prototype.listenerCount = function (t) {
          if (this._events) {
            var e = this._events[t];
            if (n(e)) return 1;
            if (e) return e.length;
          }
          return 0;
        }),
        (i.listenerCount = function (t, e) {
          return t.listenerCount(e);
        });
    },
    function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = i(5),
        r = i(17);
      new n.TwentyFive({
        slides: r.slidesManager.getGroup(1),
        sections: ["#aboutus", "#ourpath", "#career", "#contact"],
        footerSections: ["#offices", "#imprint"],
        transDuration: 1200,
        transEasing: "easeInOutCubic",
        carouselPauseTime: 6e3,
      });
      !(function () {
        if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
          var t = document.createElement("style");
          t.appendChild(
            document.createTextNode("@-ms-viewport{width:auto!important}")
          ),
            document.head.appendChild(t);
        }
        var e = window.document.createEvent("UIEvents");
        e.initUIEvent("resize", !0, !1, window, 0),
          window.dispatchEvent(e),
          setTimeout(function () {
            document.querySelector("body").style.visibility = "visible";
          }, 100);
      })();
    },
    function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = i(6),
        r = i(7),
        o = i(11),
        s = i(12),
        a = i(13),
        u = i(0),
        c = i(14),
        l = (function () {
          function t(t) {
            var e = this;
            (this._menuTimeoutDuration = 500),
              (this._transDone = !0),
              (this._stage = document.querySelector("#pi-stage")),
              (this._slides = []);
            var i = 1;
            t.slides.forEach(function (i, n) {
              e._slides.push(
                new r.Slide(i, n, 0, t.transDuration, t.transEasing, 0 === n)
              );
            }),
              (this._sections = []),
              t.sections.forEach(function (n, r) {
                e._sections.push(
                  new o.Section(n, r, i++, t.transDuration, t.transEasing)
                );
              }),
              (this._footerSections = []),
              t.footerSections.forEach(function (n, r) {
                e._footerSections.push(
                  new a.FooterSection(n, r, i++, t.transDuration, t.transEasing)
                );
              }),
              (this._transDuration = t.transDuration || 1e3),
              (this._transEasing = t.transEasing || "easeInOutSine"),
              (this._carouselPauseDuration = t.carouselPauseTime || 8e3),
              (this._curentSlideDx = 0),
              (this._mcStage = new n(this._stage)),
              this._mcStage
                .get("pan")
                .set({ direction: n.DIRECTION_VERTICAL, threshold: 30 }),
              (this._vSwipeHandler = this._touchHandler.bind(this)),
              (this._wheelHandler = this._wh.bind(this)),
              this._prepareTitles(),
              this._resizeHandler(),
              this._setupMenu(),
              this._initIndicatiors(),
              this._initEventListeners(),
              this._slides[0].on("ready", function () {
                e.activateSlide(e._slides[0]);
              });
          }
          return (
            (t.prototype._navsActivate = function (t) {
              t instanceof r.Slide
                ? this._mainNav.setActive(0)
                : t instanceof o.Section
                ? this._mainNav.setActive(t.index + 1)
                : this._mainNav.setActive(this._sections.length + 1 + t.index);
            }),
            (t.prototype._prepareTitles = function () {
              var t = u.detectIE();
              t &&
                t < 12 &&
                u.qsForEach(
                  document.querySelectorAll(
                    ".section-title img,.slide-title img"
                  ),
                  function (t, e) {
                    t.src = t.src.replace(".svg", ".png");
                  }
                );
            }),
            (t.prototype._nextElement = function () {
              console.log("nextElement")
              if (this._activeElement instanceof r.Slide){
                console.log("isSlide")
                return this._sections[0];
              }
              var t =
                this._activeElement instanceof o.Section
                  ? this._sections
                  : this._footerSections;
                  console.log('t',t)
                  console.log('thisActive',this._activeElement)
              return this._activeElement.index < t.length - 1
                ? t[this._activeElement.index + 1]
                : this._activeElement instanceof o.Section
                ? this._footerSections[0]
                : void 0;
            }),
            (t.prototype._prevtElement = function () {
              var t =
                this._activeElement instanceof o.Section
                  ? this._sections
                  : this._footerSections;
              return this._activeElement.index > 0
                ? t[this._activeElement.index - 1]
                : this._activeElement instanceof a.FooterSection
                ? this._sections[this._sections.length - 1]
                : this._activeElement instanceof o.Section
                ? this._slides[this._curentSlideDx]
                : void 0;
            }),
            (t.prototype.activateElement = function (t, e) {
              void 0 === e && (e = "down"),
                !t ||
                  this._activeElement === t ||
                  (this._activeElement instanceof r.Slide && "down" !== e) ||
                  (this._activeElement.transOut("down" !== e),
                  t.transIn("down" !== e),
                  this._navsActivate(t),
                  (this._activeElement = t),
                  this._syncIndicators(),
                  "down" === e
                    ? this._stopAutoSlide()
                    : t instanceof r.Slide && this._startAutoSlide());
            }),
            (t.prototype.scrollDown = function () {
              var t = this._nextElement();
              t && this.activateElement(t);
            }),
            (t.prototype.scrollUp = function () {
              var t = this._prevtElement();
              t && this.activateElement(t, "Up");
            }),
            (t.prototype.activateSlide = function (t) {
              if (!t) return console.log("Error:EmptySlideId"), !1;
              this._activeElement instanceof r.Slide &&
                this._activeElement.slideOut(),
                t.slideIn(),
                (this._activeElement = t),
                (this._curentSlideDx = t.index);
            }),
            (t.prototype._startAutoSlide = function () {
              console.log("start autoslide")
              let vid = document.querySelector('video');
              console.log("Video started!");
              vid.play();
            }),
            (t.prototype._stopAutoSlide = function () {
            //clearInterval(this._autoSlideTimeoutId);
              console.log("stop autoslide");
              let vid = document.querySelector('video');
              vid.pause();
              vid.currentTime = 0;
              console.log("Video stopped!");
            }),
            (t.prototype._setupMenu = function () {
              var t = this;
              (this._mainNav = new s.Nav(".navbar.fixed-top")),
                document
                  .querySelector(".navbar.fixed-top .navbar-brand")
                  .addEventListener("click", function () {
                    t.activateElement(t._slides[t._curentSlideDx], "up");
                  }),
                this._mainNav.addItem("Welcome", function () {
                  t._mainNav.setActive(0),
                    clearTimeout(t._menuTimeoutId),
                    (t._menuTimeoutId = window.setTimeout(function () {
                      t._mainNav.hamburgerToggler(),
                        t.activateElement(t._slides[t._curentSlideDx], "up");
                    }, t._menuTimeoutDuration));
                }),
                this._mainNav.setActive(0),
                ["About us", "Our path", "Join us", "Contact"].forEach(function (
                  e,
                  i
                ) {
                  t._mainNav.addItem(e, function (e) {
                    t._mainNav.setActive(e),
                      clearTimeout(t._menuTimeoutId),
                      (t._menuTimeoutId = window.setTimeout(function () {
                        t._mainNav.hamburgerToggler(),
                          t.activateElement(
                            t._sections[i],
                            t._sections[i].sort > t._activeElement.sort
                              ? "down"
                              : "up"
                          );
                      }, t._menuTimeoutDuration));
                  });
                }),
                u.qsForEach(
                  document.querySelectorAll("#career a, #career .to-contact"),
                  function (e) {
                    e.addEventListener("click", function () {
                      t.activateElement(t._sections[3], "down");
                    });
                  }
                ),
                ["Offices", "Imprint"].forEach(function (e, i) {
                  t._mainNav.addItem(e, function (e) {
                    t._mainNav.setActive(e),
                      clearTimeout(t._menuTimeoutId),
                      (t._menuTimeoutId = window.setTimeout(function () {
                        t._mainNav.hamburgerToggler(),
                          t.activateElement(
                            t._footerSections[i],
                            t._footerSections[i].sort > t._activeElement.sort
                              ? "down"
                              : "up"
                          );
                      }, t._menuTimeoutDuration));
                  });
                });
            }),
            (t.prototype._initEventListeners = function () {
              var t = this;
              window.addEventListener("resize", function () {
                t._resizeHandler();
              }),
                window.addEventListener("wheel", this._wheelHandler, !1),
                "ontouchstart" in document.documentElement &&
                  this._mcStage.on("panup pandown", this._vSwipeHandler),
                window.addEventListener("keydown", function (e) {
                  clearTimeout(t._wheelTimeoutId),
                    (t._wheelTimeoutId = window.setTimeout(function () {
                      t._keyDownHandler(e);
                    }, 500));
                });
            }),
            (t.prototype._initIndicatiors = function () {
              var t = this,
                e = document.querySelector("#sections-indicators");
              e &&
                this._sections.forEach(function (i) {
                  var n = document.createElement("li");
                  (n.id = i.id.replace("#", "") + "-indicator"),
                    n.addEventListener("click", function () {
                      t.activateElement(
                        i,
                        i.sort > t._activeElement.sort ? "down" : "up"
                      );
                    }),
                    e.appendChild(n);
                });
            }),
            (t.prototype._syncIndicators = function () {
              var t = document.querySelector("#sections-indicators");
              if (!u.isMobileLayout())
                if (this._activeElement instanceof o.Section) {
                  u.removeClass(t, "hidden");
                  var e = t.querySelector(".active");
                  e && (e.className = ""),
                    (t.querySelector(
                      this._activeElement.id + "-indicator"
                    ).className = "active");
                } else u.addClass(t, "hidden");
            }),
            (t.prototype._resizeHandler = function () {
              var t = this,
                e = this._resizeTimeoutId ? 20 : 0;
              clearTimeout(this._resizeTimeoutId),
                (this._resizeTimeoutId = window.setTimeout(function () {
                  var e = window.innerWidth,
                    i = window.innerHeight;
                  if (
                    !(
                      u.isMobileLayout() &&
                      t._activeElement instanceof o.Section &&
                      "#contact" == t._activeElement.id &&
                      "details" == t._activeElement.state
                    )
                  ) {
                    var n = u.isMobileLayout();
                    (t._stage.className = e / i > 0.9 ? "desktop" : "mobile"),
                      e / i > 1.25
                        ? u.qsForEach(
                            t._stage.querySelectorAll(".slide .slide-background"),
                            function (t) {
                              var e = t.className.replace(
                                /(desktop|mobile)/g,
                                ""
                              );
                              t.className = e.trim() + " desktop";
                            }
                          )
                        : u.qsForEach(
                            t._stage.querySelectorAll(".slide .slide-background"),
                            function (t) {
                              var e = t.className.replace(
                                /(desktop|mobile)/g,
                                ""
                              );
                              t.className = e.trim() + " mobile";
                            }
                          ),
                      t._activeElement instanceof o.Section &&
                        u.isMobileLayout() != n &&
                        (t._sections.forEach(function (t) {
                          t.resetDom();
                        }),
                        t._activeElement.transIn());
                  }
                }, e));
            }),
            (t.prototype._wh = function (t) {
              var e = this;
              if (
                !(
                  this._activeElement instanceof o.Section &&
                  "details" == this._activeElement.state
                )
              ) {
                window.removeEventListener("wheel", this._wheelHandler);
                var i = window.event || t;
                switch (
                  Math.max(
                    -1,
                    Math.min(1, i.wheelDelta || -i.detail || -i.deltaY)
                  )
                ) {
                  case -1:
                    this.scrollDown();
                    break;
                  case 1:
                    this.scrollUp();
                }
                setTimeout(function () {
                  window.addEventListener("wheel", e._wheelHandler, !1);
                }, this._transDuration);
              }
            }),
            (t.prototype._keyDownHandler = function (t) {
              switch (t.key) {
                case "ArrowDown":
                  this.scrollDown();
                  break;
                case "ArrowUp":
                  this.scrollUp();
              }
            }),
            (t.prototype._touchHandler = function (t) {
              var e = this;
              if (
                !(
                  this._activeElement instanceof o.Section &&
                  "details" == this._activeElement.state
                )
              ) {
                switch (
                  (this._mcStage.off("panup pandown", this._vSwipeHandler),
                  t.type)
                ) {
                  case "panup":
                    -130 < t.angle && t.angle < -50 && this.scrollDown();
                    break;
                  case "pandown":
                    50 < t.angle && t.angle < 130 && this.scrollUp();
                }
                setTimeout(function () {
                  e._mcStage.on("panup pandown", e._vSwipeHandler);
                }, this._transDuration);
              }
            }),
            t
          );
        })();
      e.TwentyFive = l;
    },
    function (t, e, i) {
      var n;
      /*! Hammer.JS - v2.0.7 - 2016-04-22
       * http://hammerjs.github.io/
       *
       * Copyright (c) 2016 Jorik Tangelder;
       * Licensed under the MIT license */
      /*! Hammer.JS - v2.0.7 - 2016-04-22
       * http://hammerjs.github.io/
       *
       * Copyright (c) 2016 Jorik Tangelder;
       * Licensed under the MIT license */
      !(function (r, o, s, a) {
        "use strict";
        var u,
          c = ["", "webkit", "Moz", "MS", "ms", "o"],
          l = o.createElement("div"),
          h = "function",
          d = Math.round,
          f = Math.abs,
          p = Date.now;
        function m(t, e, i) {
          return setTimeout(S(t, i), e);
        }
        function v(t, e, i) {
          return !!Array.isArray(t) && (_(t, i[e], i), !0);
        }
        function _(t, e, i) {
          var n;
          if (t)
            if (t.forEach) t.forEach(e, i);
            else if (t.length !== a)
              for (n = 0; n < t.length; ) e.call(i, t[n], n, t), n++;
            else for (n in t) t.hasOwnProperty(n) && e.call(i, t[n], n, t);
        }
        function g(t, e, i) {
          var n = "DEPRECATED METHOD: " + e + "\n" + i + " AT \n";
          return function () {
            var e = new Error("get-stack-trace"),
              i =
                e && e.stack
                  ? e.stack
                      .replace(/^[^\(]+?[\n$]/gm, "")
                      .replace(/^\s+at\s+/gm, "")
                      .replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@")
                  : "Unknown Stack Trace",
              o = r.console && (r.console.warn || r.console.log);
            return o && o.call(r.console, n, i), t.apply(this, arguments);
          };
        }
        u =
          "function" != typeof Object.assign
            ? function (t) {
                if (t === a || null === t)
                  throw new TypeError(
                    "Cannot convert undefined or null to object"
                  );
                for (var e = Object(t), i = 1; i < arguments.length; i++) {
                  var n = arguments[i];
                  if (n !== a && null !== n)
                    for (var r in n) n.hasOwnProperty(r) && (e[r] = n[r]);
                }
                return e;
              }
            : Object.assign;
        var y = g(
            function (t, e, i) {
              for (var n = Object.keys(e), r = 0; r < n.length; )
                (!i || (i && t[n[r]] === a)) && (t[n[r]] = e[n[r]]), r++;
              return t;
            },
            "extend",
            "Use `assign`."
          ),
          b = g(
            function (t, e) {
              return y(t, e, !0);
            },
            "merge",
            "Use `assign`."
          );
        function w(t, e, i) {
          var n,
            r = e.prototype;
          ((n = t.prototype = Object.create(r)).constructor = t),
            (n._super = r),
            i && u(n, i);
        }
        function S(t, e) {
          return function () {
            return t.apply(e, arguments);
          };
        }
        function E(t, e) {
          return typeof t == h ? t.apply((e && e[0]) || a, e) : t;
        }
        function T(t, e) {
          return t === a ? e : t;
        }
        function I(t, e, i) {
          _(M(e), function (e) {
            t.addEventListener(e, i, !1);
          });
        }
        function x(t, e, i) {
          _(M(e), function (e) {
            t.removeEventListener(e, i, !1);
          });
        }
        function O(t, e) {
          for (; t; ) {
            if (t == e) return !0;
            t = t.parentNode;
          }
          return !1;
        }
        function A(t, e) {
          return t.indexOf(e) > -1;
        }
        function M(t) {
          return t.trim().split(/\s+/g);
        }
        function P(t, e, i) {
          if (t.indexOf && !i) return t.indexOf(e);
          for (var n = 0; n < t.length; ) {
            if ((i && t[n][i] == e) || (!i && t[n] === e)) return n;
            n++;
          }
          return -1;
        }
        function D(t) {
          return Array.prototype.slice.call(t, 0);
        }
        function C(t, e, i) {
          for (var n = [], r = [], o = 0; o < t.length; ) {
            var s = e ? t[o][e] : t[o];
            P(r, s) < 0 && n.push(t[o]), (r[o] = s), o++;
          }
          return (
            i &&
              (n = e
                ? n.sort(function (t, i) {
                    return t[e] > i[e];
                  })
                : n.sort()),
            n
          );
        }
        function L(t, e) {
          for (
            var i, n, r = e[0].toUpperCase() + e.slice(1), o = 0;
            o < c.length;
  
          ) {
            if ((n = (i = c[o]) ? i + r : e) in t) return n;
            o++;
          }
          return a;
        }
        var q = 1;
        function k(t) {
          var e = t.ownerDocument || t;
          return e.defaultView || e.parentWindow || r;
        }
        var H = "ontouchstart" in r,
          F = L(r, "PointerEvent") !== a,
          N =
            H &&
            /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
          z = 25,
          j = 1,
          R = 2,
          W = 4,
          X = 8,
          Y = 1,
          G = 2,
          B = 4,
          U = 8,
          V = 16,
          Q = G | B,
          Z = U | V,
          $ = Q | Z,
          J = ["x", "y"],
          K = ["clientX", "clientY"];
        function tt(t, e) {
          var i = this;
          (this.manager = t),
            (this.callback = e),
            (this.element = t.element),
            (this.target = t.options.inputTarget),
            (this.domHandler = function (e) {
              E(t.options.enable, [t]) && i.handler(e);
            }),
            this.init();
        }
        function et(t, e, i) {
          var n = i.pointers.length,
            r = i.changedPointers.length,
            o = e & j && n - r == 0,
            s = e & (W | X) && n - r == 0;
          (i.isFirst = !!o),
            (i.isFinal = !!s),
            o && (t.session = {}),
            (i.eventType = e),
            (function (t, e) {
              var i = t.session,
                n = e.pointers,
                r = n.length;
              i.firstInput || (i.firstInput = it(e));
              r > 1 && !i.firstMultiple
                ? (i.firstMultiple = it(e))
                : 1 === r && (i.firstMultiple = !1);
              var o = i.firstInput,
                s = i.firstMultiple,
                u = s ? s.center : o.center,
                c = (e.center = nt(n));
              (e.timeStamp = p()),
                (e.deltaTime = e.timeStamp - o.timeStamp),
                (e.angle = at(u, c)),
                (e.distance = st(u, c)),
                (function (t, e) {
                  var i = e.center,
                    n = t.offsetDelta || {},
                    r = t.prevDelta || {},
                    o = t.prevInput || {};
                  (e.eventType !== j && o.eventType !== W) ||
                    ((r = t.prevDelta = { x: o.deltaX || 0, y: o.deltaY || 0 }),
                    (n = t.offsetDelta = { x: i.x, y: i.y }));
                  (e.deltaX = r.x + (i.x - n.x)), (e.deltaY = r.y + (i.y - n.y));
                })(i, e),
                (e.offsetDirection = ot(e.deltaX, e.deltaY));
              var l = rt(e.deltaTime, e.deltaX, e.deltaY);
              (e.overallVelocityX = l.x),
                (e.overallVelocityY = l.y),
                (e.overallVelocity = f(l.x) > f(l.y) ? l.x : l.y),
                (e.scale = s
                  ? ((h = s.pointers),
                    (d = n),
                    st(d[0], d[1], K) / st(h[0], h[1], K))
                  : 1),
                (e.rotation = s
                  ? (function (t, e) {
                      return at(e[1], e[0], K) + at(t[1], t[0], K);
                    })(s.pointers, n)
                  : 0),
                (e.maxPointers = i.prevInput
                  ? e.pointers.length > i.prevInput.maxPointers
                    ? e.pointers.length
                    : i.prevInput.maxPointers
                  : e.pointers.length),
                (function (t, e) {
                  var i,
                    n,
                    r,
                    o,
                    s = t.lastInterval || e,
                    u = e.timeStamp - s.timeStamp;
                  if (e.eventType != X && (u > z || s.velocity === a)) {
                    var c = e.deltaX - s.deltaX,
                      l = e.deltaY - s.deltaY,
                      h = rt(u, c, l);
                    (n = h.x),
                      (r = h.y),
                      (i = f(h.x) > f(h.y) ? h.x : h.y),
                      (o = ot(c, l)),
                      (t.lastInterval = e);
                  } else
                    (i = s.velocity),
                      (n = s.velocityX),
                      (r = s.velocityY),
                      (o = s.direction);
                  (e.velocity = i),
                    (e.velocityX = n),
                    (e.velocityY = r),
                    (e.direction = o);
                })(i, e);
              var h, d;
              var m = t.element;
              O(e.srcEvent.target, m) && (m = e.srcEvent.target);
              e.target = m;
            })(t, i),
            t.emit("hammer.input", i),
            t.recognize(i),
            (t.session.prevInput = i);
        }
        function it(t) {
          for (var e = [], i = 0; i < t.pointers.length; )
            (e[i] = {
              clientX: d(t.pointers[i].clientX),
              clientY: d(t.pointers[i].clientY),
            }),
              i++;
          return {
            timeStamp: p(),
            pointers: e,
            center: nt(e),
            deltaX: t.deltaX,
            deltaY: t.deltaY,
          };
        }
        function nt(t) {
          var e = t.length;
          if (1 === e) return { x: d(t[0].clientX), y: d(t[0].clientY) };
          for (var i = 0, n = 0, r = 0; r < e; )
            (i += t[r].clientX), (n += t[r].clientY), r++;
          return { x: d(i / e), y: d(n / e) };
        }
        function rt(t, e, i) {
          return { x: e / t || 0, y: i / t || 0 };
        }
        function ot(t, e) {
          return t === e ? Y : f(t) >= f(e) ? (t < 0 ? G : B) : e < 0 ? U : V;
        }
        function st(t, e, i) {
          i || (i = J);
          var n = e[i[0]] - t[i[0]],
            r = e[i[1]] - t[i[1]];
          return Math.sqrt(n * n + r * r);
        }
        function at(t, e, i) {
          i || (i = J);
          var n = e[i[0]] - t[i[0]],
            r = e[i[1]] - t[i[1]];
          return (180 * Math.atan2(r, n)) / Math.PI;
        }
        tt.prototype = {
          handler: function () {},
          init: function () {
            this.evEl && I(this.element, this.evEl, this.domHandler),
              this.evTarget && I(this.target, this.evTarget, this.domHandler),
              this.evWin && I(k(this.element), this.evWin, this.domHandler);
          },
          destroy: function () {
            this.evEl && x(this.element, this.evEl, this.domHandler),
              this.evTarget && x(this.target, this.evTarget, this.domHandler),
              this.evWin && x(k(this.element), this.evWin, this.domHandler);
          },
        };
        var ut = { mousedown: j, mousemove: R, mouseup: W },
          ct = "mousedown",
          lt = "mousemove mouseup";
        function ht() {
          (this.evEl = ct),
            (this.evWin = lt),
            (this.pressed = !1),
            tt.apply(this, arguments);
        }
        w(ht, tt, {
          handler: function (t) {
            var e = ut[t.type];
            e & j && 0 === t.button && (this.pressed = !0),
              e & R && 1 !== t.which && (e = W),
              this.pressed &&
                (e & W && (this.pressed = !1),
                this.callback(this.manager, e, {
                  pointers: [t],
                  changedPointers: [t],
                  pointerType: "mouse",
                  srcEvent: t,
                }));
          },
        });
        var dt = {
            pointerdown: j,
            pointermove: R,
            pointerup: W,
            pointercancel: X,
            pointerout: X,
          },
          ft = { 2: "touch", 3: "pen", 4: "mouse", 5: "kinect" },
          pt = "pointerdown",
          mt = "pointermove pointerup pointercancel";
        function vt() {
          (this.evEl = pt),
            (this.evWin = mt),
            tt.apply(this, arguments),
            (this.store = this.manager.session.pointerEvents = []);
        }
        r.MSPointerEvent &&
          !r.PointerEvent &&
          ((pt = "MSPointerDown"),
          (mt = "MSPointerMove MSPointerUp MSPointerCancel")),
          w(vt, tt, {
            handler: function (t) {
              var e = this.store,
                i = !1,
                n = t.type.toLowerCase().replace("ms", ""),
                r = dt[n],
                o = ft[t.pointerType] || t.pointerType,
                s = "touch" == o,
                a = P(e, t.pointerId, "pointerId");
              r & j && (0 === t.button || s)
                ? a < 0 && (e.push(t), (a = e.length - 1))
                : r & (W | X) && (i = !0),
                a < 0 ||
                  ((e[a] = t),
                  this.callback(this.manager, r, {
                    pointers: e,
                    changedPointers: [t],
                    pointerType: o,
                    srcEvent: t,
                  }),
                  i && e.splice(a, 1));
            },
          });
        var _t = { touchstart: j, touchmove: R, touchend: W, touchcancel: X },
          gt = "touchstart",
          yt = "touchstart touchmove touchend touchcancel";
        function bt() {
          (this.evTarget = gt),
            (this.evWin = yt),
            (this.started = !1),
            tt.apply(this, arguments);
        }
        w(bt, tt, {
          handler: function (t) {
            var e = _t[t.type];
            if ((e === j && (this.started = !0), this.started)) {
              var i = function (t, e) {
                var i = D(t.touches),
                  n = D(t.changedTouches);
                e & (W | X) && (i = C(i.concat(n), "identifier", !0));
                return [i, n];
              }.call(this, t, e);
              e & (W | X) &&
                i[0].length - i[1].length == 0 &&
                (this.started = !1),
                this.callback(this.manager, e, {
                  pointers: i[0],
                  changedPointers: i[1],
                  pointerType: "touch",
                  srcEvent: t,
                });
            }
          },
        });
        var wt = { touchstart: j, touchmove: R, touchend: W, touchcancel: X },
          St = "touchstart touchmove touchend touchcancel";
        function Et() {
          (this.evTarget = St), (this.targetIds = {}), tt.apply(this, arguments);
        }
        w(Et, tt, {
          handler: function (t) {
            var e = wt[t.type],
              i = function (t, e) {
                var i = D(t.touches),
                  n = this.targetIds;
                if (e & (j | R) && 1 === i.length)
                  return (n[i[0].identifier] = !0), [i, i];
                var r,
                  o,
                  s = D(t.changedTouches),
                  a = [],
                  u = this.target;
                if (
                  ((o = i.filter(function (t) {
                    return O(t.target, u);
                  })),
                  e === j)
                )
                  for (r = 0; r < o.length; ) (n[o[r].identifier] = !0), r++;
                r = 0;
                for (; r < s.length; )
                  n[s[r].identifier] && a.push(s[r]),
                    e & (W | X) && delete n[s[r].identifier],
                    r++;
                if (!a.length) return;
                return [C(o.concat(a), "identifier", !0), a];
              }.call(this, t, e);
            i &&
              this.callback(this.manager, e, {
                pointers: i[0],
                changedPointers: i[1],
                pointerType: "touch",
                srcEvent: t,
              });
          },
        });
        var Tt = 2500,
          It = 25;
        function xt() {
          tt.apply(this, arguments);
          var t = S(this.handler, this);
          (this.touch = new Et(this.manager, t)),
            (this.mouse = new ht(this.manager, t)),
            (this.primaryTouch = null),
            (this.lastTouches = []);
        }
        function Ot(t) {
          var e = t.changedPointers[0];
          if (e.identifier === this.primaryTouch) {
            var i = { x: e.clientX, y: e.clientY };
            this.lastTouches.push(i);
            var n = this.lastTouches;
            setTimeout(function () {
              var t = n.indexOf(i);
              t > -1 && n.splice(t, 1);
            }, Tt);
          }
        }
        w(xt, tt, {
          handler: function (t, e, i) {
            var n = "touch" == i.pointerType,
              r = "mouse" == i.pointerType;
            if (
              !(
                r &&
                i.sourceCapabilities &&
                i.sourceCapabilities.firesTouchEvents
              )
            ) {
              if (n)
                (function (t, e) {
                  t & j
                    ? ((this.primaryTouch = e.changedPointers[0].identifier),
                      Ot.call(this, e))
                    : t & (W | X) && Ot.call(this, e);
                }.call(this, e, i));
              else if (
                r &&
                function (t) {
                  for (
                    var e = t.srcEvent.clientX, i = t.srcEvent.clientY, n = 0;
                    n < this.lastTouches.length;
                    n++
                  ) {
                    var r = this.lastTouches[n],
                      o = Math.abs(e - r.x),
                      s = Math.abs(i - r.y);
                    if (o <= It && s <= It) return !0;
                  }
                  return !1;
                }.call(this, i)
              )
                return;
              this.callback(t, e, i);
            }
          },
          destroy: function () {
            this.touch.destroy(), this.mouse.destroy();
          },
        });
        var At = L(l.style, "touchAction"),
          Mt = At !== a,
          Pt = "auto",
          Dt = "manipulation",
          Ct = "none",
          Lt = "pan-x",
          qt = "pan-y",
          kt = (function () {
            if (!Mt) return !1;
            var t = {},
              e = r.CSS && r.CSS.supports;
            return (
              [
                "auto",
                "manipulation",
                "pan-y",
                "pan-x",
                "pan-x pan-y",
                "none",
              ].forEach(function (i) {
                t[i] = !e || r.CSS.supports("touch-action", i);
              }),
              t
            );
          })();
        function Ht(t, e) {
          (this.manager = t), this.set(e);
        }
        Ht.prototype = {
          set: function (t) {
            "compute" == t && (t = this.compute()),
              Mt &&
                this.manager.element.style &&
                kt[t] &&
                (this.manager.element.style[At] = t),
              (this.actions = t.toLowerCase().trim());
          },
          update: function () {
            this.set(this.manager.options.touchAction);
          },
          compute: function () {
            var t = [];
            return (
              _(this.manager.recognizers, function (e) {
                E(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
              }),
              (function (t) {
                if (A(t, Ct)) return Ct;
                var e = A(t, Lt),
                  i = A(t, qt);
                if (e && i) return Ct;
                if (e || i) return e ? Lt : qt;
                if (A(t, Dt)) return Dt;
                return Pt;
              })(t.join(" "))
            );
          },
          preventDefaults: function (t) {
            var e = t.srcEvent,
              i = t.offsetDirection;
            if (this.manager.session.prevented) e.preventDefault();
            else {
              var n = this.actions,
                r = A(n, Ct) && !kt[Ct],
                o = A(n, qt) && !kt[qt],
                s = A(n, Lt) && !kt[Lt];
              if (r) {
                var a = 1 === t.pointers.length,
                  u = t.distance < 2,
                  c = t.deltaTime < 250;
                if (a && u && c) return;
              }
              if (!s || !o)
                return r || (o && i & Q) || (s && i & Z)
                  ? this.preventSrc(e)
                  : void 0;
            }
          },
          preventSrc: function (t) {
            (this.manager.session.prevented = !0), t.preventDefault();
          },
        };
        var Ft = 1,
          Nt = 2,
          zt = 4,
          jt = 8,
          Rt = jt,
          Wt = 16;
        function Xt(t) {
          (this.options = u({}, this.defaults, t || {})),
            (this.id = q++),
            (this.manager = null),
            (this.options.enable = T(this.options.enable, !0)),
            (this.state = Ft),
            (this.simultaneous = {}),
            (this.requireFail = []);
        }
        function Yt(t) {
          return t & Wt
            ? "cancel"
            : t & jt
            ? "end"
            : t & zt
            ? "move"
            : t & Nt
            ? "start"
            : "";
        }
        function Gt(t) {
          return t == V
            ? "down"
            : t == U
            ? "up"
            : t == G
            ? "left"
            : t == B
            ? "right"
            : "";
        }
        function Bt(t, e) {
          var i = e.manager;
          return i ? i.get(t) : t;
        }
        function Ut() {
          Xt.apply(this, arguments);
        }
        function Vt() {
          Ut.apply(this, arguments), (this.pX = null), (this.pY = null);
        }
        function Qt() {
          Ut.apply(this, arguments);
        }
        function Zt() {
          Xt.apply(this, arguments), (this._timer = null), (this._input = null);
        }
        function $t() {
          Ut.apply(this, arguments);
        }
        function Jt() {
          Ut.apply(this, arguments);
        }
        function Kt() {
          Xt.apply(this, arguments),
            (this.pTime = !1),
            (this.pCenter = !1),
            (this._timer = null),
            (this._input = null),
            (this.count = 0);
        }
        function te(t, e) {
          return (
            ((e = e || {}).recognizers = T(e.recognizers, te.defaults.preset)),
            new ee(t, e)
          );
        }
        (Xt.prototype = {
          defaults: {},
          set: function (t) {
            return (
              u(this.options, t),
              this.manager && this.manager.touchAction.update(),
              this
            );
          },
          recognizeWith: function (t) {
            if (v(t, "recognizeWith", this)) return this;
            var e = this.simultaneous;
            return (
              e[(t = Bt(t, this)).id] || ((e[t.id] = t), t.recognizeWith(this)),
              this
            );
          },
          dropRecognizeWith: function (t) {
            return v(t, "dropRecognizeWith", this)
              ? this
              : ((t = Bt(t, this)), delete this.simultaneous[t.id], this);
          },
          requireFailure: function (t) {
            if (v(t, "requireFailure", this)) return this;
            var e = this.requireFail;
            return (
              -1 === P(e, (t = Bt(t, this))) &&
                (e.push(t), t.requireFailure(this)),
              this
            );
          },
          dropRequireFailure: function (t) {
            if (v(t, "dropRequireFailure", this)) return this;
            t = Bt(t, this);
            var e = P(this.requireFail, t);
            return e > -1 && this.requireFail.splice(e, 1), this;
          },
          hasRequireFailures: function () {
            return this.requireFail.length > 0;
          },
          canRecognizeWith: function (t) {
            return !!this.simultaneous[t.id];
          },
          emit: function (t) {
            var e = this,
              i = this.state;
            function n(i) {
              e.manager.emit(i, t);
            }
            i < jt && n(e.options.event + Yt(i)),
              n(e.options.event),
              t.additionalEvent && n(t.additionalEvent),
              i >= jt && n(e.options.event + Yt(i));
          },
          tryEmit: function (t) {
            if (this.canEmit()) return this.emit(t);
            this.state = 32;
          },
          canEmit: function () {
            for (var t = 0; t < this.requireFail.length; ) {
              if (!(this.requireFail[t].state & (32 | Ft))) return !1;
              t++;
            }
            return !0;
          },
          recognize: function (t) {
            var e = u({}, t);
            if (!E(this.options.enable, [this, e]))
              return this.reset(), void (this.state = 32);
            this.state & (Rt | Wt | 32) && (this.state = Ft),
              (this.state = this.process(e)),
              this.state & (Nt | zt | jt | Wt) && this.tryEmit(e);
          },
          process: function (t) {},
          getTouchAction: function () {},
          reset: function () {},
        }),
          w(Ut, Xt, {
            defaults: { pointers: 1 },
            attrTest: function (t) {
              var e = this.options.pointers;
              return 0 === e || t.pointers.length === e;
            },
            process: function (t) {
              var e = this.state,
                i = t.eventType,
                n = e & (Nt | zt),
                r = this.attrTest(t);
              return n && (i & X || !r)
                ? e | Wt
                : n || r
                ? i & W
                  ? e | jt
                  : e & Nt
                  ? e | zt
                  : Nt
                : 32;
            },
          }),
          w(Vt, Ut, {
            defaults: { event: "pan", threshold: 10, pointers: 1, direction: $ },
            getTouchAction: function () {
              var t = this.options.direction,
                e = [];
              return t & Q && e.push(qt), t & Z && e.push(Lt), e;
            },
            directionTest: function (t) {
              var e = this.options,
                i = !0,
                n = t.distance,
                r = t.direction,
                o = t.deltaX,
                s = t.deltaY;
              return (
                r & e.direction ||
                  (e.direction & Q
                    ? ((r = 0 === o ? Y : o < 0 ? G : B),
                      (i = o != this.pX),
                      (n = Math.abs(t.deltaX)))
                    : ((r = 0 === s ? Y : s < 0 ? U : V),
                      (i = s != this.pY),
                      (n = Math.abs(t.deltaY)))),
                (t.direction = r),
                i && n > e.threshold && r & e.direction
              );
            },
            attrTest: function (t) {
              return (
                Ut.prototype.attrTest.call(this, t) &&
                (this.state & Nt || (!(this.state & Nt) && this.directionTest(t)))
              );
            },
            emit: function (t) {
              (this.pX = t.deltaX), (this.pY = t.deltaY);
              var e = Gt(t.direction);
              e && (t.additionalEvent = this.options.event + e),
                this._super.emit.call(this, t);
            },
          }),
          w(Qt, Ut, {
            defaults: { event: "pinch", threshold: 0, pointers: 2 },
            getTouchAction: function () {
              return [Ct];
            },
            attrTest: function (t) {
              return (
                this._super.attrTest.call(this, t) &&
                (Math.abs(t.scale - 1) > this.options.threshold ||
                  this.state & Nt)
              );
            },
            emit: function (t) {
              if (1 !== t.scale) {
                var e = t.scale < 1 ? "in" : "out";
                t.additionalEvent = this.options.event + e;
              }
              this._super.emit.call(this, t);
            },
          }),
          w(Zt, Xt, {
            defaults: { event: "press", pointers: 1, time: 251, threshold: 9 },
            getTouchAction: function () {
              return [Pt];
            },
            process: function (t) {
              var e = this.options,
                i = t.pointers.length === e.pointers,
                n = t.distance < e.threshold,
                r = t.deltaTime > e.time;
              if (((this._input = t), !n || !i || (t.eventType & (W | X) && !r)))
                this.reset();
              else if (t.eventType & j)
                this.reset(),
                  (this._timer = m(
                    function () {
                      (this.state = Rt), this.tryEmit();
                    },
                    e.time,
                    this
                  ));
              else if (t.eventType & W) return Rt;
              return 32;
            },
            reset: function () {
              clearTimeout(this._timer);
            },
            emit: function (t) {
              this.state === Rt &&
                (t && t.eventType & W
                  ? this.manager.emit(this.options.event + "up", t)
                  : ((this._input.timeStamp = p()),
                    this.manager.emit(this.options.event, this._input)));
            },
          }),
          w($t, Ut, {
            defaults: { event: "rotate", threshold: 0, pointers: 2 },
            getTouchAction: function () {
              return [Ct];
            },
            attrTest: function (t) {
              return (
                this._super.attrTest.call(this, t) &&
                (Math.abs(t.rotation) > this.options.threshold || this.state & Nt)
              );
            },
          }),
          w(Jt, Ut, {
            defaults: {
              event: "swipe",
              threshold: 10,
              velocity: 0.3,
              direction: Q | Z,
              pointers: 1,
            },
            getTouchAction: function () {
              return Vt.prototype.getTouchAction.call(this);
            },
            attrTest: function (t) {
              var e,
                i = this.options.direction;
              return (
                i & (Q | Z)
                  ? (e = t.overallVelocity)
                  : i & Q
                  ? (e = t.overallVelocityX)
                  : i & Z && (e = t.overallVelocityY),
                this._super.attrTest.call(this, t) &&
                  i & t.offsetDirection &&
                  t.distance > this.options.threshold &&
                  t.maxPointers == this.options.pointers &&
                  f(e) > this.options.velocity &&
                  t.eventType & W
              );
            },
            emit: function (t) {
              var e = Gt(t.offsetDirection);
              e && this.manager.emit(this.options.event + e, t),
                this.manager.emit(this.options.event, t);
            },
          }),
          w(Kt, Xt, {
            defaults: {
              event: "tap",
              pointers: 1,
              taps: 1,
              interval: 300,
              time: 250,
              threshold: 9,
              posThreshold: 10,
            },
            getTouchAction: function () {
              return [Dt];
            },
            process: function (t) {
              var e = this.options,
                i = t.pointers.length === e.pointers,
                n = t.distance < e.threshold,
                r = t.deltaTime < e.time;
              if ((this.reset(), t.eventType & j && 0 === this.count))
                return this.failTimeout();
              if (n && r && i) {
                if (t.eventType != W) return this.failTimeout();
                var o = !this.pTime || t.timeStamp - this.pTime < e.interval,
                  s =
                    !this.pCenter || st(this.pCenter, t.center) < e.posThreshold;
                if (
                  ((this.pTime = t.timeStamp),
                  (this.pCenter = t.center),
                  s && o ? (this.count += 1) : (this.count = 1),
                  (this._input = t),
                  0 === this.count % e.taps)
                )
                  return this.hasRequireFailures()
                    ? ((this._timer = m(
                        function () {
                          (this.state = Rt), this.tryEmit();
                        },
                        e.interval,
                        this
                      )),
                      Nt)
                    : Rt;
              }
              return 32;
            },
            failTimeout: function () {
              return (
                (this._timer = m(
                  function () {
                    this.state = 32;
                  },
                  this.options.interval,
                  this
                )),
                32
              );
            },
            reset: function () {
              clearTimeout(this._timer);
            },
            emit: function () {
              this.state == Rt &&
                ((this._input.tapCount = this.count),
                this.manager.emit(this.options.event, this._input));
            },
          }),
          (te.VERSION = "2.0.7"),
          (te.defaults = {
            domEvents: !1,
            touchAction: "compute",
            enable: !0,
            inputTarget: null,
            inputClass: null,
            preset: [
              [$t, { enable: !1 }],
              [Qt, { enable: !1 }, ["rotate"]],
              [Jt, { direction: Q }],
              [Vt, { direction: Q }, ["swipe"]],
              [Kt],
              [Kt, { event: "doubletap", taps: 2 }, ["tap"]],
              [Zt],
            ],
            cssProps: {
              userSelect: "none",
              touchSelect: "none",
              touchCallout: "none",
              contentZooming: "none",
              userDrag: "none",
              tapHighlightColor: "rgba(0,0,0,0)",
            },
          });
        function ee(t, e) {
          var i;
          (this.options = u({}, te.defaults, e || {})),
            (this.options.inputTarget = this.options.inputTarget || t),
            (this.handlers = {}),
            (this.session = {}),
            (this.recognizers = []),
            (this.oldCssProps = {}),
            (this.element = t),
            (this.input = new ((i = this).options.inputClass ||
              (F ? vt : N ? Et : H ? xt : ht))(i, et)),
            (this.touchAction = new Ht(this, this.options.touchAction)),
            ie(this, !0),
            _(
              this.options.recognizers,
              function (t) {
                var e = this.add(new t[0](t[1]));
                t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
              },
              this
            );
        }
        function ie(t, e) {
          var i,
            n = t.element;
          n.style &&
            (_(t.options.cssProps, function (r, o) {
              (i = L(n.style, o)),
                e
                  ? ((t.oldCssProps[i] = n.style[i]), (n.style[i] = r))
                  : (n.style[i] = t.oldCssProps[i] || "");
            }),
            e || (t.oldCssProps = {}));
        }
        (ee.prototype = {
          set: function (t) {
            return (
              u(this.options, t),
              t.touchAction && this.touchAction.update(),
              t.inputTarget &&
                (this.input.destroy(),
                (this.input.target = t.inputTarget),
                this.input.init()),
              this
            );
          },
          stop: function (t) {
            this.session.stopped = t ? 2 : 1;
          },
          recognize: function (t) {
            var e = this.session;
            if (!e.stopped) {
              var i;
              this.touchAction.preventDefaults(t);
              var n = this.recognizers,
                r = e.curRecognizer;
              (!r || (r && r.state & Rt)) && (r = e.curRecognizer = null);
              for (var o = 0; o < n.length; )
                (i = n[o]),
                  2 === e.stopped || (r && i != r && !i.canRecognizeWith(r))
                    ? i.reset()
                    : i.recognize(t),
                  !r && i.state & (Nt | zt | jt) && (r = e.curRecognizer = i),
                  o++;
            }
          },
          get: function (t) {
            if (t instanceof Xt) return t;
            for (var e = this.recognizers, i = 0; i < e.length; i++)
              if (e[i].options.event == t) return e[i];
            return null;
          },
          add: function (t) {
            if (v(t, "add", this)) return this;
            var e = this.get(t.options.event);
            return (
              e && this.remove(e),
              this.recognizers.push(t),
              (t.manager = this),
              this.touchAction.update(),
              t
            );
          },
          remove: function (t) {
            if (v(t, "remove", this)) return this;
            if ((t = this.get(t))) {
              var e = this.recognizers,
                i = P(e, t);
              -1 !== i && (e.splice(i, 1), this.touchAction.update());
            }
            return this;
          },
          on: function (t, e) {
            if (t !== a && e !== a) {
              var i = this.handlers;
              return (
                _(M(t), function (t) {
                  (i[t] = i[t] || []), i[t].push(e);
                }),
                this
              );
            }
          },
          off: function (t, e) {
            if (t !== a) {
              var i = this.handlers;
              return (
                _(M(t), function (t) {
                  e ? i[t] && i[t].splice(P(i[t], e), 1) : delete i[t];
                }),
                this
              );
            }
          },
          emit: function (t, e) {
            this.options.domEvents &&
              (function (t, e) {
                var i = o.createEvent("Event");
                i.initEvent(t, !0, !0),
                  (i.gesture = e),
                  e.target.dispatchEvent(i);
              })(t, e);
            var i = this.handlers[t] && this.handlers[t].slice();
            if (i && i.length) {
              (e.type = t),
                (e.preventDefault = function () {
                  e.srcEvent.preventDefault();
                });
              for (var n = 0; n < i.length; ) i[n](e), n++;
            }
          },
          destroy: function () {
            this.element && ie(this, !1),
              (this.handlers = {}),
              (this.session = {}),
              this.input.destroy(),
              (this.element = null);
          },
        }),
          u(te, {
            INPUT_START: j,
            INPUT_MOVE: R,
            INPUT_END: W,
            INPUT_CANCEL: X,
            STATE_POSSIBLE: Ft,
            STATE_BEGAN: Nt,
            STATE_CHANGED: zt,
            STATE_ENDED: jt,
            STATE_RECOGNIZED: Rt,
            STATE_CANCELLED: Wt,
            STATE_FAILED: 32,
            DIRECTION_NONE: Y,
            DIRECTION_LEFT: G,
            DIRECTION_RIGHT: B,
            DIRECTION_UP: U,
            DIRECTION_DOWN: V,
            DIRECTION_HORIZONTAL: Q,
            DIRECTION_VERTICAL: Z,
            DIRECTION_ALL: $,
            Manager: ee,
            Input: tt,
            TouchAction: Ht,
            TouchInput: Et,
            MouseInput: ht,
            PointerEventInput: vt,
            TouchMouseInput: xt,
            SingleTouchInput: bt,
            Recognizer: Xt,
            AttrRecognizer: Ut,
            Tap: Kt,
            Pan: Vt,
            Swipe: Jt,
            Pinch: Qt,
            Rotate: $t,
            Press: Zt,
            on: I,
            off: x,
            each: _,
            merge: b,
            extend: y,
            assign: u,
            inherit: w,
            bindFn: S,
            prefixed: L,
          }),
          ((void 0 !== r
            ? r
            : "undefined" != typeof self
            ? self
            : {}
          ).Hammer = te),
          (n = function () {
            return te;
          }.call(e, i, e, t)) === a || (t.exports = n);
      })(window, document);
    },
    function (t, e, i) {
      "use strict";
      var n,
        r =
          (this && this.__extends) ||
          ((n =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
            }),
          function (t, e) {
            function i() {
              this.constructor = t;
            }
            n(t, e),
              (t.prototype =
                null === e
                  ? Object.create(e)
                  : ((i.prototype = e.prototype), new i()));
          });
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = i(1),
        s = i(8),
        a = i(3),
        u = i(0),
        c = (function (t) {
          function e(e, i, n, r, o, a) {
            void 0 === r && (r = 1e3),
              void 0 === o && (o = "easeInOutSine"),
              void 0 === a && (a = !1);
            var c = t.call(this) || this;
            (c._id = e),
              (c._index = i),
              (c._sort = n),
              (c._isActive = a),
              (c._transDuration = r),
              (c._transEasing = o),
              c._isActive ||
                (document.querySelector("" + c._id).style.left = "100vw");
            var l = document.querySelector("" + c._id);
            return (
              u.removeClass(l, "hidden"),
              //c._initDom(), c._initTimeline(), c.emit("ready")
              
              (c._sp = new s.SequencePlayer({
                path: "slides/kunal/video/",
                selector: c._id + " .slide-portrait",
                imagesCount: 124,
                staticImageIndex: 124,
                maxLoadErrors: 20,
                width: 900,
                height: 900,
                step: 1,
                latency: 1,
                serializationLength: 4,
              })),
              c._sp.on("ready", function () {
                c._initDom(), c._initTimeline(), c.emit("ready");
              }),
              c._sp.on("fail", function () {
                console.log("slide " + c._id + " failed!"), c.emit("fail");
              }),
              c
            );
          }
          return (
            r(e, t),
            Object.defineProperty(e.prototype, "id", {
              get: function () {
                return this._id;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e.prototype, "index", {
              get: function () {
                return this._index;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e.prototype, "sort", {
              get: function () {
                return this._sort;
              },
              enumerable: !0,
              configurable: !0,
            }),
            (e.prototype.transIn = function (t) {
              void 0 === t && (t = !1);
              var e = o({
                targets: "" + this._id,
                top: ["-100vh", 0],
                duration: this._transDuration,
                easing: this._transEasing,
                offset: 0,
              });
              console.log('transIn')
              return (this._isActive = !0), e.finished;
            }),
            (e.prototype.transOut = function (t) {
              void 0 === t && (t = !1);
              var e = o({
                targets: "" + this._id,
                top: [0, "-100vh"],
                duration: this._transDuration,
                easing: this._transEasing,
                offset: 0,
              });
              return (this._isActive = !1), e.finished;
            }),
            (e.prototype.slideIn = function (t) {
              var e = this;
              void 0 === t && (t = !1);
              var i = u.isMobileLayout() ? 600 : 1e3;
              return (
                this._isActive ||
                  o({
                    targets: "" + this._id,
                    left: [t ? "-100vw" : "100vw", 0],
                    duration: i,
                    easing: "easeInOutSine",
                    offset: 0,
                  }),
                this._timelineMain.restart(),
                (this._isActive = !0),
                setTimeout(function () {
                  e._sp.restart();
                }, this._transDuration),
                this._initDom(),
                this._timelineMain.finished
              );
            }),
            (e.prototype.slideOut = function (t) {
              var e = this;
              void 0 === t && (t = !1);
              var i = u.isMobileLayout() ? 600 : 1e3,
                n = o({
                  targets: "" + this._id,
                  left: [0, t ? "100vw" : "-100vw"],
                  duration: i,
                  easing: "easeInOutSine",
                  offset: 0,
                });
              return (
                this._sp.stop(),
                setTimeout(function () {
                  e._sp.reset();
                }, this._transDuration),
                (this._isActive = !1),
                n.finished
              );
            }),
            (e.prototype._initTimeline = function () {
              var t = this;
              this._timelineMain = o.timeline({
                loop: !1,
                direction: "normal",
                autoplay: !1,
              });
              var e = 1;
              u.isMobileLayout() && (e = 2),
                this._timelineMain;
              var i = 0;
            }),
            (e.prototype._initDom = function () {
              console.log('initDom')
            }),
            e
          );
        })(a.EventEmitter);
      e.Slide = c;
    },
    function (t, e, i) {
      "use strict";
      var n,
        r =
          (this && this.__extends) ||
          ((n =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
            }),
          function (t, e) {
            function i() {
              this.constructor = t;
            }
            n(t, e),
              (t.prototype =
                null === e
                  ? Object.create(e)
                  : ((i.prototype = e.prototype), new i()));
          });
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = i(0),
        s = i(3),
        a = i(9),
        u = (function (t) {
          function e(e) {
            var i = t.call(this) || this;
            if (
              ((i._frameDx = 0),
              (i._tickCount = 0),
              (i._conf = e),
              (i._images = []),
              (i._stop = !1),
              (i._isReady = !1),
              (i._dom = document.querySelector(e.selector)),
              !i._dom)
            )
              throw new Error(
                "SequencePlayer unable to locate dom element using the selector " +
                  e.selector
              );
            var n = new Image();
            n.src =
              "" +
              i._conf.path +
              o.paddy(i._conf.staticImageIndex, i._conf.serializationLength) +
              ".png";
            var r = Date.now();
            return (
              (n.onload = function () {
                i._conf.width || (i._conf.width = n.width),
                  i._conf.height || (i._conf.height = n.height),
                  i._conf.loop || (i._conf.loop = !1),
                  i._conf.autoPlay || (i._conf.autoPlay = !1),
                  (i._dom.width = i._conf.width),
                  (i._dom.height = i._conf.height),
                  (i._context = i._dom.getContext("2d")),
                  (i._conf.rendWidth =
                    i._conf.width < n.width ? i._conf.width : n.width),
                  (i._conf.rendHeight =
                    i._conf.height < n.height ? i._conf.height : n.height),
                  i._context.drawImage(
                    n,
                    0,
                    0,
                    i._conf.rendWidth,
                    i._conf.rendHeight,
                    0,
                    0,
                    i._conf.rendWidth,
                    i._conf.rendHeight
                  ),
                  i.emit("ready"),
                  Date.now() - r < 900 &&
                    i
                      ._loadImages()
                      .then(function () {
                        i._images.sort(function (t, e) {
                          var i = parseInt(t.dataset.dx),
                            n = parseInt(e.dataset.dx);
                          return i < n ? -1 : i > n ? 1 : 0;
                        }),
                          i._render(),
                          (i._isReady = !0),
                          i._conf.autoPlay && i.play();
                      })
                      .catch(function () {
                        console.log("ERRR: " + n.src + " FAILED....");
                      });
              }),
              (n.onerror = function () {
                console.log("Static image: " + n.src + " failed!"),
                  i.emit("fail");
              }),
              i
            );
          }
          return (
            r(e, t),
            Object.defineProperty(e.prototype, "isReady", {
              get: function () {
                return this._isReady;
              },
              enumerable: !0,
              configurable: !0,
            }),
            (e.prototype.play = function () {
              !this._isReady ||
                this._images.length < 2 ||
                (this._frameDx < this._images.length - 1 && (this._stop = !1),
                this._run());
            }),
            (e.prototype.stop = function () {
              this._stop = !0;
            }),
            (e.prototype.restart = function () {
              this.reset(), this.play();
            }),
            (e.prototype.reset = function () {
              (this._frameDx = 0),
                (this._stop = !1),
                !this._isReady || this._images.length < 2 || this._render();
            }),
            (e.prototype._loadImages = function () {
              var t = this,
                e = this._conf.path,
                i = this._conf.maxLoadErrors || 3,
                n = 0,
                r = 0;
              return new a.Promise(function (s, a) {
                for (
                  var u = function (u) {
                      var c = new Image();
                      (c.src =
                        "" +
                        e +
                        o.paddy(u, t._conf.serializationLength) +
                        ".png"),
                        (c.dataset.dx = "" + u),
                        c.addEventListener("error", function () {
                          ++n >= i &&
                            a(
                              new Error(
                                "Image Loader Errors has reached it's max limit!!"
                              )
                            );
                        }),
                        c.addEventListener("load", function () {
                          r++,
                            t._images.push(c),
                            r + n >=
                              Math.floor(t._conf.imagesCount / t._conf.step) &&
                              r >=
                                Math.floor(t._conf.imagesCount / t._conf.step) -
                                  i &&
                              s("ImageLoader done! img.src=" + c.src);
                        });
                    },
                    c = 0;
                  c < t._conf.imagesCount;
                  c += t._conf.step
                )
                  u(c);
              });
            }),
            (e.prototype._render = function () {
              this._context.clearRect(
                0,
                0,
                this._conf.rendWidth,
                this._conf.rendHeight
              ),
                this._context.drawImage(
                  this._images[this._frameDx],
                  0,
                  0,
                  this._conf.rendWidth,
                  this._conf.rendHeight,
                  0,
                  0,
                  this._conf.rendWidth,
                  this._conf.rendHeight
                );
            }),
            (e.prototype._update = function () {
              this._tickCount++,
                this._tickCount > this._conf.latency &&
                  ((this._tickCount = 0),
                  this._frameDx < this._images.length - 1
                    ? this._frameDx++
                    : this._conf.loop
                    ? (this._frameDx = 0)
                    : (this._stop = !0));
            }),
            (e.prototype._run = function () {
              var t = this;
              this._stop ||
                ((
                  window.msRequestAnimationFrame ||
                  window.mozRequestAnimationFrame ||
                  window.webkitRequestAnimationFrame ||
                  window.oRequestAnimationFrame ||
                  window.requestAnimationFrame
                )(function () {
                  t._run();
                }),
                this._update(),
                this._render());
            }),
            e
          );
        })(s.EventEmitter);
      e.SequencePlayer = u;
    },
    function (t, e, i) {
      (function (e, i) {
        /*!
         * @overview es6-promise - a tiny implementation of Promises/A+.
         * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
         * @license   Licensed under MIT license
         *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
         * @version   v4.2.4+314e4831
         */ var n;
        (n = function () {
          "use strict";
          function t(t) {
            return "function" == typeof t;
          }
          var n = Array.isArray
              ? Array.isArray
              : function (t) {
                  return "[object Array]" === Object.prototype.toString.call(t);
                },
            r = 0,
            o = void 0,
            s = void 0,
            a = function (t, e) {
              (p[r] = t), (p[r + 1] = e), 2 === (r += 2) && (s ? s(m) : b());
            };
          var u = "undefined" != typeof window ? window : void 0,
            c = u || {},
            l = c.MutationObserver || c.WebKitMutationObserver,
            h =
              "undefined" == typeof self &&
              void 0 !== e &&
              "[object process]" === {}.toString.call(e),
            d =
              "undefined" != typeof Uint8ClampedArray &&
              "undefined" != typeof importScripts &&
              "undefined" != typeof MessageChannel;
          function f() {
            var t = setTimeout;
            return function () {
              return t(m, 1);
            };
          }
          var p = new Array(1e3);
          function m() {
            for (var t = 0; t < r; t += 2) {
              (0, p[t])(p[t + 1]), (p[t] = void 0), (p[t + 1] = void 0);
            }
            r = 0;
          }
          var v,
            _,
            g,
            y,
            b = void 0;
          function w(t, e) {
            var i = this,
              n = new this.constructor(T);
            void 0 === n[E] && z(n);
            var r = i._state;
            if (r) {
              var o = arguments[r - 1];
              a(function () {
                return F(r, n, o, i._result);
              });
            } else k(i, n, t, e);
            return n;
          }
          function S(t) {
            if (t && "object" == typeof t && t.constructor === this) return t;
            var e = new this(T);
            return D(e, t), e;
          }
          h
            ? (b = function () {
                return e.nextTick(m);
              })
            : l
            ? ((_ = 0),
              (g = new l(m)),
              (y = document.createTextNode("")),
              g.observe(y, { characterData: !0 }),
              (b = function () {
                y.data = _ = ++_ % 2;
              }))
            : d
            ? (((v = new MessageChannel()).port1.onmessage = m),
              (b = function () {
                return v.port2.postMessage(0);
              }))
            : (b =
                void 0 === u
                  ? (function () {
                      try {
                        var t = Function("return this")().require("vertx");
                        return void 0 !== (o = t.runOnLoop || t.runOnContext)
                          ? function () {
                              o(m);
                            }
                          : f();
                      } catch (t) {
                        return f();
                      }
                    })()
                  : f());
          var E = Math.random().toString(36).substring(2);
          function T() {}
          var I = void 0,
            x = 1,
            O = 2,
            A = { error: null };
          function M(t) {
            try {
              return t.then;
            } catch (t) {
              return (A.error = t), A;
            }
          }
          function P(e, i, n) {
            i.constructor === e.constructor &&
            n === w &&
            i.constructor.resolve === S
              ? (function (t, e) {
                  e._state === x
                    ? L(t, e._result)
                    : e._state === O
                    ? q(t, e._result)
                    : k(
                        e,
                        void 0,
                        function (e) {
                          return D(t, e);
                        },
                        function (e) {
                          return q(t, e);
                        }
                      );
                })(e, i)
              : n === A
              ? (q(e, A.error), (A.error = null))
              : void 0 === n
              ? L(e, i)
              : t(n)
              ? (function (t, e, i) {
                  a(function (t) {
                    var n = !1,
                      r = (function (t, e, i, n) {
                        try {
                          t.call(e, i, n);
                        } catch (t) {
                          return t;
                        }
                      })(
                        i,
                        e,
                        function (i) {
                          n || ((n = !0), e !== i ? D(t, i) : L(t, i));
                        },
                        function (e) {
                          n || ((n = !0), q(t, e));
                        },
                        t._label
                      );
                    !n && r && ((n = !0), q(t, r));
                  }, t);
                })(e, i, n)
              : L(e, i);
          }
          function D(t, e) {
            var i, n;
            t === e
              ? q(t, new TypeError("You cannot resolve a promise with itself"))
              : ((n = typeof (i = e)),
                null === i || ("object" !== n && "function" !== n)
                  ? L(t, e)
                  : P(t, e, M(e)));
          }
          function C(t) {
            t._onerror && t._onerror(t._result), H(t);
          }
          function L(t, e) {
            t._state === I &&
              ((t._result = e),
              (t._state = x),
              0 !== t._subscribers.length && a(H, t));
          }
          function q(t, e) {
            t._state === I && ((t._state = O), (t._result = e), a(C, t));
          }
          function k(t, e, i, n) {
            var r = t._subscribers,
              o = r.length;
            (t._onerror = null),
              (r[o] = e),
              (r[o + x] = i),
              (r[o + O] = n),
              0 === o && t._state && a(H, t);
          }
          function H(t) {
            var e = t._subscribers,
              i = t._state;
            if (0 !== e.length) {
              for (
                var n = void 0, r = void 0, o = t._result, s = 0;
                s < e.length;
                s += 3
              )
                (n = e[s]), (r = e[s + i]), n ? F(i, n, r, o) : r(o);
              t._subscribers.length = 0;
            }
          }
          function F(e, i, n, r) {
            var o = t(n),
              s = void 0,
              a = void 0,
              u = void 0,
              c = void 0;
            if (o) {
              if (
                ((s = (function (t, e) {
                  try {
                    return t(e);
                  } catch (t) {
                    return (A.error = t), A;
                  }
                })(n, r)) === A
                  ? ((c = !0), (a = s.error), (s.error = null))
                  : (u = !0),
                i === s)
              )
                return void q(
                  i,
                  new TypeError(
                    "A promises callback cannot return that same promise."
                  )
                );
            } else (s = r), (u = !0);
            i._state !== I ||
              (o && u
                ? D(i, s)
                : c
                ? q(i, a)
                : e === x
                ? L(i, s)
                : e === O && q(i, s));
          }
          var N = 0;
          function z(t) {
            (t[E] = N++),
              (t._state = void 0),
              (t._result = void 0),
              (t._subscribers = []);
          }
          var j = (function () {
            function t(t, e) {
              (this._instanceConstructor = t),
                (this.promise = new t(T)),
                this.promise[E] || z(this.promise),
                n(e)
                  ? ((this.length = e.length),
                    (this._remaining = e.length),
                    (this._result = new Array(this.length)),
                    0 === this.length
                      ? L(this.promise, this._result)
                      : ((this.length = this.length || 0),
                        this._enumerate(e),
                        0 === this._remaining && L(this.promise, this._result)))
                  : q(
                      this.promise,
                      new Error("Array Methods must be provided an Array")
                    );
            }
            return (
              (t.prototype._enumerate = function (t) {
                for (var e = 0; this._state === I && e < t.length; e++)
                  this._eachEntry(t[e], e);
              }),
              (t.prototype._eachEntry = function (t, e) {
                var i = this._instanceConstructor,
                  n = i.resolve;
                if (n === S) {
                  var r = M(t);
                  if (r === w && t._state !== I)
                    this._settledAt(t._state, e, t._result);
                  else if ("function" != typeof r)
                    this._remaining--, (this._result[e] = t);
                  else if (i === R) {
                    var o = new i(T);
                    P(o, t, r), this._willSettleAt(o, e);
                  } else
                    this._willSettleAt(
                      new i(function (e) {
                        return e(t);
                      }),
                      e
                    );
                } else this._willSettleAt(n(t), e);
              }),
              (t.prototype._settledAt = function (t, e, i) {
                var n = this.promise;
                n._state === I &&
                  (this._remaining--, t === O ? q(n, i) : (this._result[e] = i)),
                  0 === this._remaining && L(n, this._result);
              }),
              (t.prototype._willSettleAt = function (t, e) {
                var i = this;
                k(
                  t,
                  void 0,
                  function (t) {
                    return i._settledAt(x, e, t);
                  },
                  function (t) {
                    return i._settledAt(O, e, t);
                  }
                );
              }),
              t
            );
          })();
          var R = (function () {
            function t(e) {
              (this[E] = N++),
                (this._result = this._state = void 0),
                (this._subscribers = []),
                T !== e &&
                  ("function" != typeof e &&
                    (function () {
                      throw new TypeError(
                        "You must pass a resolver function as the first argument to the promise constructor"
                      );
                    })(),
                  this instanceof t
                    ? (function (t, e) {
                        try {
                          e(
                            function (e) {
                              D(t, e);
                            },
                            function (e) {
                              q(t, e);
                            }
                          );
                        } catch (e) {
                          q(t, e);
                        }
                      })(this, e)
                    : (function () {
                        throw new TypeError(
                          "Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function."
                        );
                      })());
            }
            return (
              (t.prototype.catch = function (t) {
                return this.then(null, t);
              }),
              (t.prototype.finally = function (t) {
                var e = this.constructor;
                return this.then(
                  function (i) {
                    return e.resolve(t()).then(function () {
                      return i;
                    });
                  },
                  function (i) {
                    return e.resolve(t()).then(function () {
                      throw i;
                    });
                  }
                );
              }),
              t
            );
          })();
          return (
            (R.prototype.then = w),
            (R.all = function (t) {
              return new j(this, t).promise;
            }),
            (R.race = function (t) {
              var e = this;
              return n(t)
                ? new e(function (i, n) {
                    for (var r = t.length, o = 0; o < r; o++)
                      e.resolve(t[o]).then(i, n);
                  })
                : new e(function (t, e) {
                    return e(new TypeError("You must pass an array to race."));
                  });
            }),
            (R.resolve = S),
            (R.reject = function (t) {
              var e = new this(T);
              return q(e, t), e;
            }),
            (R._setScheduler = function (t) {
              s = t;
            }),
            (R._setAsap = function (t) {
              a = t;
            }),
            (R._asap = a),
            (R.polyfill = function () {
              var t = void 0;
              if (void 0 !== i) t = i;
              else if ("undefined" != typeof self) t = self;
              else
                try {
                  t = Function("return this")();
                } catch (t) {
                  throw new Error(
                    "polyfill failed because global object is unavailable in this environment"
                  );
                }
              var e = t.Promise;
              if (e) {
                var n = null;
                try {
                  n = Object.prototype.toString.call(e.resolve());
                } catch (t) {}
                if ("[object Promise]" === n && !e.cast) return;
              }
              t.Promise = R;
            }),
            (R.Promise = R),
            R
          );
        }),
          (t.exports = n());
      }.call(e, i(10), i(2)));
    },
    function (t, e) {
      var i,
        n,
        r = (t.exports = {});
      function o() {
        throw new Error("setTimeout has not been defined");
      }
      function s() {
        throw new Error("clearTimeout has not been defined");
      }
      function a(t) {
        if (i === setTimeout) return setTimeout(t, 0);
        if ((i === o || !i) && setTimeout)
          return (i = setTimeout), setTimeout(t, 0);
        try {
          return i(t, 0);
        } catch (e) {
          try {
            return i.call(null, t, 0);
          } catch (e) {
            return i.call(this, t, 0);
          }
        }
      }
      !(function () {
        try {
          i = "function" == typeof setTimeout ? setTimeout : o;
        } catch (t) {
          i = o;
        }
        try {
          n = "function" == typeof clearTimeout ? clearTimeout : s;
        } catch (t) {
          n = s;
        }
      })();
      var u,
        c = [],
        l = !1,
        h = -1;
      function d() {
        l &&
          u &&
          ((l = !1), u.length ? (c = u.concat(c)) : (h = -1), c.length && f());
      }
      function f() {
        if (!l) {
          var t = a(d);
          l = !0;
          for (var e = c.length; e; ) {
            for (u = c, c = []; ++h < e; ) u && u[h].run();
            (h = -1), (e = c.length);
          }
          (u = null),
            (l = !1),
            (function (t) {
              if (n === clearTimeout) return clearTimeout(t);
              if ((n === s || !n) && clearTimeout)
                return (n = clearTimeout), clearTimeout(t);
              try {
                n(t);
              } catch (e) {
                try {
                  return n.call(null, t);
                } catch (e) {
                  return n.call(this, t);
                }
              }
            })(t);
        }
      }
      function p(t, e) {
        (this.fun = t), (this.array = e);
      }
      function m() {}
      (r.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1)
          for (var i = 1; i < arguments.length; i++) e[i - 1] = arguments[i];
        c.push(new p(t, e)), 1 !== c.length || l || a(f);
      }),
        (p.prototype.run = function () {
          this.fun.apply(null, this.array);
        }),
        (r.title = "browser"),
        (r.browser = !0),
        (r.env = {}),
        (r.argv = []),
        (r.version = ""),
        (r.versions = {}),
        (r.on = m),
        (r.addListener = m),
        (r.once = m),
        (r.off = m),
        (r.removeListener = m),
        (r.removeAllListeners = m),
        (r.emit = m),
        (r.prependListener = m),
        (r.prependOnceListener = m),
        (r.listeners = function (t) {
          return [];
        }),
        (r.binding = function (t) {
          throw new Error("process.binding is not supported");
        }),
        (r.cwd = function () {
          return "/";
        }),
        (r.chdir = function (t) {
          throw new Error("process.chdir is not supported");
        }),
        (r.umask = function () {
          return 0;
        });
    },
    function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = i(1),
        r = i(0),
        o = (function () {
          function t(t, e, i, n, o) {
            void 0 === n && (n = 1e3), void 0 === o && (o = "easeInOutSine");
            var s = this;
            if (
              ((this._id = t),
              (this._index = e),
              (this._sort = i),
              (this._isActive = !1),
              (this._PSD_SPECS = {
                desktop: {
                  fullWidth: 1300,
                  fullHeight: 740,
                  width: 1080,
                  height: 580,
                  titleHeight: 75,
                  headlineFSize: 40,
                  headlineLH: 50,
                  copyFSize: 20,
                  copyLH: 24,
                  introLeft: 50,
                  detailsLeft: 150,
                  button: { width: 128, height: 44, fontSize: 16 },
                  form: {
                    inputWidth: 430,
                    inputHeight: 36,
                    inputSpacing: 12,
                    textAreaHeight: 160,
                    fontSize: 14,
                  },
                  intro: document.querySelector(this._id + " .section-intro"),
                  details: document.querySelector(this._id + " .section-details"),
                  introTitle: document.querySelector(
                    this._id + " .section-title img"
                  ),
                  introHeadline: document.querySelector(
                    this._id + " .section-headline"
                  ),
                  introCopy: document.querySelector(this._id + " .section-copy"),
                  detailsHeadline: document.querySelector(
                    this._id + " .section-details h2"
                  ),
                  detailsCopy: document.querySelector(
                    this._id + " .section-details"
                  ),
                  controlBtns: document.querySelectorAll(
                    this._id + " button.only-desktop" + "," + this._id + " a.button.only-desktop"
                  ),
                  contactForm: document.querySelector(
                    this._id + " .form .section-desktop"
                  ),
                  contactFormSendBtns: document.querySelectorAll(
                    this._id + " .form .section-desktop button"
                  ),
                },
                mobile: {
                  fullWidth: 375,
                  fullHeight: 667,
                  width: "100%",
                  height: "100%",
                  introLeft: 0,
                  detailsLeft: 100,
                  titleHeight: 60,
                  headlineFSize: 27,
                  headlineLH: 33,
                  copyLH: 21,
                  copyFSize: 17,
                  button: { width: 128, height: 44, fontSize: 16 },
                  form: {
                    inputWidth: 90,
                    inputHeight: 20,
                    inputSpacing: 10,
                    textAreaHeight: 120,
                    fontSize: 12,
                  },
                  intro: document.querySelector(this._id + " .section-intro"),
                  details: document.querySelector(this._id + " .section-details"),
                  introTitle: document.querySelector(
                    this._id + " .section-title img"
                  ),
                  introHeadline: document.querySelector(
                    this._id + " .section-headline"
                  ),
                  introCopy: document.querySelector(this._id + " .section-copy"),
                  detailsHeadline: document.querySelector(
                    this._id + " .section-details .section-mobile h2"
                  ),
                  detailsCopy: document.querySelector(
                    this._id + " .section-details .section-mobile p"
                  ),
                  arrowBtn: document.querySelector(
                    this._id + " .section-intro .control.only-mobile"
                  ),
                  controlBtns: [],
                  contactForm: document.querySelector(
                    this._id + " .form .section-mobile"
                  ),
                  contactFormSendBtn: document.querySelector(
                    this._id + " .form .section-mobile button"
                  ),
                },
              }),
              (this._transInDuration = n),
              (this._transOutDuration = n + 100),
              (this._transInEasing = o),
              (this._transOutEasing = o),
              this._initTimeline(),
              (document.querySelector(this._id).style.display = "none"),
              r.qsForEach(
                document.querySelectorAll(this._id + " .control-intro_details"),
                function (t) {
                  t.addEventListener("click", function () {
                    "details" === s._state
                      ? s.transToIntro()
                      : s.transToDetails();
                  });
                }
              ),
              r.qsForEach(
                document.querySelectorAll(this._id + " .control-details_intro"),
                function (t) {
                  t.addEventListener("click", function () {
                    s.transToIntro();
                  });
                }
              ),
              window.addEventListener("resize", function () {
                clearTimeout(s._resizeTimeoutId),
                  (s._resizeTimeoutId = window.setTimeout(function () {
                    s._resizeHandler();
                  }, 100));
              }),
              this._PSD_SPECS.mobile.intro &&
                "ontouchstart" in document.documentElement)
            ) {
              var a = new Hammer(this._PSD_SPECS.mobile.intro);
              a
                .get("pan")
                .set({ direction: Hammer.DIRECTION_LEFT, threshold: 50 }),
                a.on("panleft", function (t) {
                  clearTimeout(s._panTimeoutId),
                    (s._panTimeoutId = window.setTimeout(function () {
                      ((150 < t.angle && t.angle < 180) ||
                        (-180 < t.angle && t.angle < -140)) &&
                        s.transToDetails();
                    }, 50));
                });
            }
            if (
              this._PSD_SPECS.mobile.details &&
              "ontouchstart" in document.documentElement
            ) {
              var u = new Hammer(this._PSD_SPECS.mobile.details);
              u
                .get("pan")
                .set({ direction: Hammer.DIRECTION_RIGHT, threshold: 50 }),
                u.on("panright", function (t) {
                  clearTimeout(s._panTimeoutId),
                    (s._panTimeoutId = window.setTimeout(function () {
                      -40 < t.angle && t.angle < 40 && s.transToIntro();
                    }, 50));
                });
            }
            "#contact" === this._id &&
              setTimeout(function () {
                s._initContact();
              }, 500);
          }
          return (
            Object.defineProperty(t.prototype, "id", {
              get: function () {
                return this._id;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "index", {
              get: function () {
                return this._index;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "sort", {
              get: function () {
                return this._sort;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "state", {
              get: function () {
                return this._state;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "dom", {
              get: function () {
                return this._PSD_SPECS;
              },
              enumerable: !0,
              configurable: !0,
            }),
            (t.prototype.transIn = function (t) {
              var e = this;
              void 0 === t && (t = !1),
                (this._timelineIn = n.timeline({ loop: !1, autoplay: !1 }));
              var i = 40,
                o = t ? { s: "-100vh", e: "0" } : { s: "100vh", e: "0" },
                s = t ? { s: "-100vh", e: "0" } : { s: "100vh", e: "0" };
              return (
                this._timelineOut.pause(),
                (document.querySelector(this._id).style.display = "block"),
                r.isMobileLayout() &&
                  ((o = t ? { s: "-150%", e: "5%" } : { s: "100%", e: "5%" }),
                  (s = t ? { s: "-100%", e: "50%" } : { s: "150%", e: "50%" }),
                  (i = 0),
                  this._timelineIn
                    .add({
                      targets: this._id + " .mobile-control-wrapper",
                      opacity: [0, 1],
                      durarion: 50,
                      offset: 0,
                      delay: this._transInDuration - 200,
                      easing: "linear",
                    })
                    .add({
                      targets: this._id + " .section-mobile",
                      top: t ? ["-100%", "0"] : ["100%", "0"],
                      duration: this._transOutDuration + i,
                      offset: 0,
                      easing: this._transOutEasing,
                    })),
                this._timelineIn
                  .add({
                    targets:
                      this._id +
                      " .section-picture," +
                      this._id +
                      " .section-left",
                    top: [o.s, o.e],
                    duration: this._transInDuration,
                    offset: 0,
                    easing: this._transInEasing,
                  })
                  .add({
                    targets:
                      this._id +
                      " .section-text, " +
                      this._id +
                      " .section-right",
                    top: [s.s, s.e],
                    duration: this._transInDuration + i,
                    offset: 0,
                    easing: this._transInEasing,
                  })
                  .add({
                    targets: this._id + " .only-desktop.control-intro_details",
                    translateY: ["0", "100%"],
                    duration: 200,
                    offset: 0,
                    delay: this._transInDuration - 200,
                    easing: "easeOutQuad",
                  }),
                this._timelineIn.finished &&
                  this._timelineIn.finished.then(function () {
                    e._isActive = !0;
                  }),
                this._timelineIn.restart(),
                this._timelineMain.restart(),
                this._timelineMain.finished
              );
            }),
            (t.prototype.transOut = function (t) {
              var e = this;
              void 0 === t && (t = !1),
                (this._timelineOut = n.timeline({ loop: !1, autoplay: !1 }));
              var i = 40,
                o = t ? { s: "0", e: "100vh" } : { s: "0", e: "-100vh" },
                s = t ? { s: "0", e: "100vh" } : { s: "0", e: "-100vh" };
              return (
                r.isMobileLayout() &&
                  ((o = t ? { s: "5%", e: "100%" } : { s: "5%", e: "-100%" }),
                  (s = t ? { s: "50%", e: "150%" } : { s: "50%", e: "-150%" }),
                  (i = 100),
                  this._timelineOut
                    .add({
                      targets: this._id + " .mobile-control-wrapper",
                      opacity: [1, 0],
                      durarion: 50,
                      offset: 0,
                      delay: 0,
                      easing: "linear",
                    })
                    .add({
                      targets: this._id + " .section-mobile",
                      top: t ? ["0", "100%"] : ["0", "-100%"],
                      duration: this._transOutDuration + i,
                      offset: 0,
                      easing: this._transOutEasing,
                    })),
                this._timelineOut
                  .add({
                    targets:
                      this._id +
                      " .section-picture, " +
                      this._id +
                      " .section-left",
                    top: [o.s, o.e],
                    duration: this._transOutDuration,
                    offset: 0,
                    easing: this._transOutEasing,
                  })
                  .add({
                    targets:
                      this._id +
                      " .section-text ," +
                      this._id +
                      " .section-right",
                    top: [s.s, s.e],
                    duration: this._transOutDuration + i,
                    offset: 0,
                    easing: this._transOutEasing,
                  })
                  .add({
                    targets: this._id + " .only-desktop.control-intro_details",
                    translateY: ["100%", "0"],
                    duration: 200,
                    delay: 0,
                    offset: 0,
                    easing: "easeInQuad",
                  }),
                this._timelineOut.finished &&
                  this._timelineOut.finished.then(function () {
                    (e._isActive = !1),
                      (document.querySelector(e._id).style.display = "none");
                  }),
                this._timelineOut.restart(),
                this._timelineOut.finished
              );
            }),
            (t.prototype.transToDetails = function () {
              var t = r.isMobileLayout() ? 50 : 0;
              this._state = "details";
              var e = document.querySelector("#sections-indicators");
              r.addClass(e, "hidden");
              var i = n.timeline({ loop: !1, autoplay: !0 });
              return (
                i
                  .add({
                    targets: this._id + " .section-intro",
                    left: [50 - t + "vw", -50 - t + "vw"],
                    duration: 1e3,
                    offset: 0,
                    easing: "easeInOutSine",
                  })
                  .add({
                    targets: this._id + " .section-details",
                    left: [150 - t + "vw", 50 - t + "vw"],
                    duration: 1e3,
                    offset: 0,
                    easing: "easeInOutSine",
                  })
                  .add({
                    targets:
                      this._id +
                      " .section-details .section-shapes>img:first-of-type",
                    scale: [0, 1],
                    duration: this._transInDuration,
                    easing: "easeOutQuad",
                    offset: 0,
                    delay: 500,
                  })
                  .add({
                    targets:
                      this._id +
                      " .section-details .section-shapes>img:last-of-type",
                    scale: [0, 1],
                    duration: this._transInDuration + 100,
                    easing: "easeOutCubic",
                    offset: 0,
                    delay: 600,
                  }),
                r.addClass(this._PSD_SPECS.mobile.arrowBtn, "active"),
                (this._PSD_SPECS.mobile.arrowBtn.style.position = "fixed"),
                i.finished
              );
            }),
            (t.prototype.transToIntro = function () {
              var t = this,
                e = r.isMobileLayout() ? 50 : 0,
                i = document.querySelector("#sections-indicators");
              this._state = "intro";
              var o = n.timeline({ loop: !1, autoplay: !0 });
              return (
                o
                  .add({
                    targets: this._id + " .section-intro",
                    left: [-50 - e + "vw", 50 - e + "vw"],
                    duration: 1e3,
                    offset: 0,
                    easing: "easeInOutSine",
                  })
                  .add({
                    targets: this._id + " .section-details",
                    left: [50 - e + "vw", 150 - e + "vw"],
                    duration: 1e3,
                    offset: 0,
                    easing: "easeInOutSine",
                  })
                  .add({
                    targets:
                      this._id +
                      " .section-intro .section-shapes>img:first-of-type",
                    scale: [0, 1],
                    duration: this._transInDuration,
                    easing: "easeOutQuad",
                    offset: 0,
                    delay: 500,
                  })
                  .add({
                    targets:
                      this._id +
                      " .section-intro .section-shapes>img:last-of-type",
                    scale: [0, 1],
                    duration: this._transInDuration + 100,
                    easing: "easeOutCubic",
                    offset: 0,
                    delay: 600,
                  }),
                setTimeout(function () {
                  ((t._PSD_SPECS.mobile.arrowBtn.style.position = ""),
                  r.removeClass(i, "hidden"),
                  "#contact" == t._id) &&
                    (t._toggleThanks(!0),
                    (document
                      .getElementById("contact")
                      .querySelector(".section-mobile").style.top = ""));
                }, this._transInDuration),
                r.removeClass(this._PSD_SPECS.mobile.arrowBtn, "active"),
                o.finished
              );
            }),
            (t.prototype.resetDom = function () {
              var t = r.isMobileLayout()
                  ? this._PSD_SPECS.mobile
                  : this._PSD_SPECS.desktop,
                e = 0;
              "details" == this.state && (e = 100),
                (t.intro.style.left = t.introLeft - e + "vw"),
                (t.details.style.left = t.detailsLeft - e + "vw");
            }),
            (t.prototype._initTimeline = function () {
              var t = this;
              (this._timelineIn = n.timeline({ loop: !1, autoplay: !1 })),
                (this._timelineOut = n.timeline({ loop: !1, autoplay: !1 })),
                (this._timelineMain = n.timeline({ loop: !1, autoplay: !1 })),
                this._timelineMain
                  .add({
                    targets: this._id + " .section-intro>.section-picture>img",
                    scale: [1, 1.07],
                    duration: 8e3,
                    easing: "linear",
                    offset: 0,
                    delay: 700,
                  })
                  .add({
                    targets: this._id + " .section-shapes>img:first-of-type",
                    scale: [0, 1],
                    duration: this._transInDuration,
                    easing: "easeOutQuad",
                    offset: 0,
                    delay: 900,
                  })
                  .add({
                    targets: this._id + " .section-shapes>img:last-of-type",
                    scale: [0, 1],
                    duration: this._transInDuration + 100,
                    easing: "easeOutCubic",
                    offset: 0,
                    delay: 1100,
                  });
              var e = 0;
              this._timelineMain.add({
                targets: this._id + " .section-headline",
                width: [0, "90%"],
                duration: this._transInDuration + 200,
                easing: "easeInCubic",
                offset: 0,
                delay: 250 + 100 * e,
              }),
                r.qsForEach(
                  document.querySelectorAll(this._id + " .section-headline>div"),
                  function (i, n) {
                    e++,
                      t._timelineMain.add({
                        targets: i,
                        translateX: [50 + 5 * e + "px", "0"],
                        duration: t._transInDuration - 200,
                        easing: "easeOutSine",
                        offset: 0,
                        delay: 300 + 100 * e,
                      });
                  }
                ),
                this._timelineMain.add({
                  targets: this._id + " .section-copy",
                  width: [0, "90%"],
                  duration: this._transInDuration + 200,
                  easing: "easeInCubic",
                  offset: 0,
                  delay: 250 + 100 * e,
                }),
                r.qsForEach(
                  document.querySelectorAll(this._id + " .section-copy>div"),
                  function (i, n) {
                    e++,
                      t._timelineMain.add({
                        targets: i,
                        translateX: [50 + 5 * e + "px", "0"],
                        duration: t._transInDuration - 200,
                        easing: "easeOutSine",
                        offset: 0,
                        delay: 300 + 100 * e,
                      });
                  }
                ),
                this._timelineMain.add({
                  targets: this._id + " .section-title",
                  width: [0, "90%"],
                  duration: this._transInDuration + 200,
                  easing: "easeInCubic",
                  offset: 0,
                  delay: 250 + 100 * e,
                }),
                e++,
                this._timelineMain.add({
                  targets: this._id + " .section-title>div",
                  translateX: [50 + 5 * e + "px", "0"],
                  duration: this._transInDuration - 200,
                  easing: "easeOutSine",
                  offset: 0,
                  delay: 300 + 100 * e,
                });
            }),
            (t.prototype._resizeHandler = function () {
              if (
                r.isMobileLayout() &&
                "#contact" == this._id &&
                "details" == this._state
              ) {
                window.innerHeight > 450 &&
                  (document
                    .getElementById("contact")
                    .querySelector(".section-mobile").style.top = "");
              } else {
                var t = r.isMobileLayout(),
                  e = window.innerWidth,
                  i = window.innerHeight,
                  n = t ? this._PSD_SPECS.mobile : this._PSD_SPECS.desktop,
                  o =
                    e / i > n.fullWidth / n.fullHeight
                      ? i / n.fullHeight
                      : e / n.fullWidth;
                if (
                  (e >= n.fullWidth && i >= n.fullHeight && (o = 1),
                  n.intro &&
                    n.details &&
                    ((n.intro.style.height = n.details.style.height =
                      "100%" === n.height
                        ? "100%"
                        : Math.floor(n.height * o) + "px"),
                    (n.intro.style.width = n.details.style.width =
                      "100%" === n.width
                        ? "100%"
                        : Math.floor(n.width * o) + "px")),
                  n.introTitle &&
                    (n.introTitle.style.height =
                      Math.floor(n.titleHeight * o) + "px"),
                  n.introHeadline &&
                    n.detailsHeadline &&
                    ((n.introHeadline.style.fontSize = n.detailsHeadline.style.fontSize =
                      Math.floor(n.headlineFSize * o) + "px"),
                    (n.introHeadline.style.lineHeight = n.detailsHeadline.style.lineHeight =
                      Math.floor(n.headlineLH * o) + "px")),
                  "#contact" == this._id &&
                    ((document.querySelector(
                      this._id + " .section-details .section-thanks h2"
                    ).style.fontSize = Math.floor(n.headlineFSize * o) + "px"),
                    (document.querySelector(
                      this._id + " .section-details .section-thanks h2"
                    ).style.lineHeight = Math.floor(n.headlineLH * o) + "px")),
                  n.introCopy &&
                    ((n.introCopy.style.fontSize =
                      Math.floor(n.copyFSize * o) + "px"),
                    (n.introCopy.style.lineHeight =
                      Math.floor(n.copyLH * o) + "px")),
                  n.detailsCopy &&
                    ((n.detailsCopy.style.fontSize =
                      Math.floor((n.copyFSize - 2) * o) + "px"),
                    (n.detailsCopy.style.lineHeight =
                      n.introCopy.style.lineHeight)),
                  r.qsForEach(n.controlBtns, function (t) {
                    (t.style.fontSize = Math.floor(n.button.fontSize * o) + "px"),
                      (t.style.height = Math.floor(n.button.height * o) + "px"),
                      (t.style.width = Math.floor(n.button.width * o) + "px");
                  }),
                  n.contactForm)
                ) {
                  r.qsForEach(n.contactForm.querySelectorAll("input"), function (
                    e
                  ) {
                    (e.style.fontSize = Math.floor(n.form.fontSize * o) + "px"),
                      (e.style.height =
                        Math.floor(n.form.inputHeight * o) + "px"),
                      (e.style.width = t
                        ? "90%"
                        : Math.floor(n.form.inputWidth * o) + "px"),
                      (e.style.marginBottom =
                        Math.floor(n.form.inputSpacing * o) + "px");
                  });
                  var s = n.contactForm.querySelector("textarea");
                  (s.style.height = Math.floor(n.form.textAreaHeight * o) + "px"),
                    (s.style.width = t
                      ? "90%"
                      : Math.floor(n.form.inputWidth * o) + "px"),
                    (s.style.fontSize = Math.floor(n.form.fontSize * o) + "px");
                }
              }
            }),
            (t.prototype._initContact = function () {
              var t = this,
                e = r.isMobileLayout()
                  ? this._PSD_SPECS.mobile
                  : this._PSD_SPECS.desktop,
                i = document.querySelector(this._id + " .form");
              if (
                "Android" === r.getMobileOperatingSystem() &&
                r.isMobileLayout() &&
                i
              ) {
                var n = i.querySelector(".section-mobile");
                r.qsForEach(n.querySelectorAll("input,textarea"), function (t) {
                  t.onfocus = function (t) {
                    if ((t.preventDefault, !(window.innerHeight > 450))) {
                      var e = t.target.offsetTop,
                        i = document
                          .getElementById("contact")
                          .querySelector(".section-mobile"),
                        n =
                          e +
                          i.querySelector(".section-form").offsetTop -
                          0.333 * window.innerHeight;
                      i.style.top = n > 0 ? -n + "px" : "";
                    }
                  };
                });
              }
              i
                ? i.addEventListener("submit", function (i) {
                    i.preventDefault();
                    var n = e.contactForm.querySelector("input[name='fname']"),
                      o = e.contactForm.querySelector("input[name='lname']"),
                      s = e.contactForm.querySelector("input[name='email']"),
                      a = e.contactForm.querySelector("textarea[name='message']"),
                      u = e.contactForm.querySelector(".error-msg"),
                      c = !1;
                    if (
                      (n.value.length < 3
                        ? (r.addClass(n, "error"), (c = !0))
                        : r.removeClass(n, "error"),
                      o.value.length < 3
                        ? (r.addClass(o, "error"), (c = !0))
                        : r.removeClass(o, "error"),
                      a.value.length < 10
                        ? (r.addClass(a, "error"), (c = !0))
                        : r.removeClass(a, "error"),
                      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                        s.value
                      )
                        ? r.removeClass(s, "error")
                        : (r.addClass(s, "error"), (c = !0)),
                      c)
                    )
                      r.removeClass(u, "hidden");
                    else {
                      r.addClass(u, "hidden");
                      var l =
                          "fname=" +
                          n.value +
                          "&lname=" +
                          o.value +
                          "&email=" +
                          s.value +
                          "&message=" +
                          a.value,
                        h = new XMLHttpRequest();
                      h.open("post", "mailer.php"),
                        h.setRequestHeader(
                          "Content-Type",
                          "application/x-www-form-urlencoded"
                        ),
                        h.send(l),
                        h.addEventListener("load", function (e) {
                          t._toggleThanks();
                        }),
                        h.addEventListener("error", function (t) {
                          console.log(h.response);
                        });
                    }
                  })
                : console.log("form not avaliable");
            }),
            (t.prototype._toggleThanks = function (t) {
              void 0 === t && (t = !1);
              var e = document.querySelector("#contact .section-thanks");
              document.querySelector("#contact .form");
              t
                ? (e.style.display = "none")
                : "none" == e.style.display
                ? (e.style.display = "block")
                : (e.style.display = "none");
            }),
            t
          );
        })();
      e.Section = o;
    },
    function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = (function () {
        function t(t) {
          var e = this;
          if (((this._dom = document.querySelector(t)), !this._dom))
            throw new Error(
              "Error: no element found using the SELECTOR: " + t + "!!!"
            );
          (this._items = []),
            (this._brand = this._dom.querySelector(".navbar-brand")),
            (this._burger = this._dom.querySelector(".hamburger")),
            (this._collapse = this._dom.querySelector(
              ".navbar-collapse .navbar-nav"
            )),
            this._burger.addEventListener("click", function () {
              e.hamburgerToggler();
            }),
            window.addEventListener("resize", function () {
              clearTimeout(e._resizeTimeoutId),
                (e._resizeTimeoutId = window.setTimeout(function () {
                  e._resizeHandler();
                }, 500));
            }),
            this._resizeHandler();
        }
        return (
          Object.defineProperty(t.prototype, "length", {
            get: function () {
              return this._items.length;
            },
            enumerable: !0,
            configurable: !0,
          }),
          (t.prototype.addItem = function (t, e) {
            var i = document.createElement("li"),
              n = "" + this._items.length;
            return (
              (i.className = "nav-item"),
              (i.innerHTML = '<a class="nav-link" href="#">' + t + "</a>"),
              i.addEventListener("click", function () {
                e(parseInt(n));
              }),
              this._collapse.appendChild(i),
              this._items.push(i),
              this
            );
          }),
          (t.prototype.setActive = function (t) {
            (this._items[t] &&
              -1 !== this._items[t].className.indexOf("active")) ||
              this._items.forEach(function (e, i) {
                (e.className = e.className.replace("active", "").trim()),
                  i === t && (e.className += " active");
              });
          }),
          (t.prototype.hamburgerToggler = function () {
            this._dom.className =
              -1 == this._dom.className.indexOf("is-active")
                ? (this._dom.className += " is-active")
                : this._dom.className.replace("is-active", "").trim();
          }),
          (t.prototype._resizeHandler = function () {
            var t = window.innerWidth,
              e = window.innerHeight,
              i = (this._dom.className = this._dom.className
                .replace(/(desktop|mobile)/, "")
                .trim());
            this._dom.className = t / e > 0.9 ? i + " desktop" : i + " mobile";
          }),
          t
        );
      })();
      e.Nav = n;
    },
    function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = i(1),
        r = (function () {
          function t(t, e, i, r, o) {
            void 0 === r && (r = 1e3),
              void 0 === o && (o = "easeInOutSine"),
              (this._id = t),
              (this._index = e),
              (this._sort = i),
              (this._isActive = !1),
              (this._transInDuration = r),
              (this._transOutDuration = r + 100),
              (this._transInEasing = o),
              (this._transOutEasing = o),
              (this._timelineIn = n.timeline({ loop: !1, autoplay: !1 })),
              (this._timelineOut = n.timeline({ loop: !1, autoplay: !1 }));
          }
          return (
            Object.defineProperty(t.prototype, "id", {
              get: function () {
                return this._id;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "index", {
              get: function () {
                return this._index;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "sort", {
              get: function () {
                return this._sort;
              },
              enumerable: !0,
              configurable: !0,
            }),
            (t.prototype.transIn = function (t) {
              var e = this;
              void 0 === t && (t = !1),
                (this._timelineIn = n.timeline({ loop: !1, autoplay: !1 }));
              var i = t ? { s: "-100vh", e: "0" } : { s: "100vh", e: "0" };
              return (
                this._timelineOut.pause(),
                (document.querySelector(this._id).style.display = "block"),
                this._timelineIn.add({
                  targets: this._id,
                  top: [i.s, i.e],
                  duration: this._transInDuration,
                  offset: 0,
                  easing: this._transInEasing,
                }),
                this._timelineIn.finished &&
                  this._timelineIn.finished.then(function () {
                    e._isActive = !0;
                  }),
                this._timelineIn.restart(),
                this._timelineIn.finished
              );
            }),
            (t.prototype.transOut = function (t) {
              void 0 === t && (t = !1),
                (this._timelineOut = n.timeline({ loop: !1, autoplay: !1 }));
              var e = t ? { s: "0", e: "100vh" } : { s: "0", e: "-100vh" };
              return (
                this._timelineOut.add({
                  targets: this._id,
                  top: [e.s, e.e],
                  duration: this._transOutDuration,
                  offset: 0,
                  easing: this._transOutEasing,
                }),
                this._timelineOut.restart(),
                this._timelineOut.finished
              );
            }),
            t
          );
        })();
      e.FooterSection = r;
    },
    function (t, e, i) {
      t.exports = i(15);
    },
    function (t, e, i) {
      !(function (e) {
        "use strict";
        var n = -1,
          r = function (t) {
            return (
              (t.every = function (e, i, r) {
                t._time(), r || ((r = i), (i = null));
                var o = (n += 1);
                return (
                  (t._timers[o] = { visible: e, hidden: i, callback: r }),
                  t._run(o, !1),
                  t.isSupported() && t._listen(),
                  o
                );
              }),
              (t.stop = function (e) {
                return !!t._timers[e] && (t._stop(e), delete t._timers[e], !0);
              }),
              (t._timers = {}),
              (t._time = function () {
                t._timed ||
                  ((t._timed = !0),
                  (t._wasHidden = t.hidden()),
                  t.change(function () {
                    t._stopRun(), (t._wasHidden = t.hidden());
                  }));
              }),
              (t._run = function (i, n) {
                var r,
                  o = t._timers[i];
                if (t.hidden()) {
                  if (null === o.hidden) return;
                  r = o.hidden;
                } else r = o.visible;
                var s = function () {
                  (o.last = new Date()), o.callback.call(e);
                };
                if (n) {
                  var a = new Date() - o.last;
                  r > a
                    ? (o.delay = setTimeout(function () {
                        (o.id = setInterval(s, r)), s();
                      }, r - a))
                    : ((o.id = setInterval(s, r)), s());
                } else o.id = setInterval(s, r);
              }),
              (t._stop = function (e) {
                var i = t._timers[e];
                clearInterval(i.id),
                  clearTimeout(i.delay),
                  delete i.id,
                  delete i.delay;
              }),
              (t._stopRun = function (e) {
                var i = t.hidden(),
                  n = t._wasHidden;
                if ((i && !n) || (!i && n))
                  for (var r in t._timers) t._stop(r), t._run(r, !i);
              }),
              t
            );
          };
        void 0 !== t && t.exports ? (t.exports = r(i(16))) : r(e.Visibility);
      })(window);
    },
    function (t, e) {
      !(function (e) {
        "use strict";
        var i = -1,
          n = {
            onVisible: function (t) {
              var e = n.isSupported();
              if (!e || !n.hidden()) return t(), e;
              var i = n.change(function (e, r) {
                n.hidden() || (n.unbind(i), t());
              });
              return i;
            },
            change: function (t) {
              if (!n.isSupported()) return !1;
              var e = (i += 1);
              return (n._callbacks[e] = t), n._listen(), e;
            },
            unbind: function (t) {
              delete n._callbacks[t];
            },
            afterPrerendering: function (t) {
              var e = n.isSupported();
              if (!e || "prerender" != n.state()) return t(), e;
              var i = n.change(function (e, r) {
                "prerender" != r && (n.unbind(i), t());
              });
              return i;
            },
            hidden: function () {
              return !(!n._doc.hidden && !n._doc.webkitHidden);
            },
            state: function () {
              return (
                n._doc.visibilityState ||
                n._doc.webkitVisibilityState ||
                "visible"
              );
            },
            isSupported: function () {
              return !(!n._doc.visibilityState && !n._doc.webkitVisibilityState);
            },
            _doc: document || {},
            _callbacks: {},
            _change: function (t) {
              var e = n.state();
              for (var i in n._callbacks) n._callbacks[i].call(n._doc, t, e);
            },
            _listen: function () {
              if (!n._init) {
                var t = "visibilitychange";
                n._doc.webkitVisibilityState && (t = "webkit" + t);
                var e = function () {
                  n._change.apply(n, arguments);
                };
                n._doc.addEventListener
                  ? n._doc.addEventListener(t, e)
                  : n._doc.attachEvent(t, e),
                  (n._init = !0);
              }
            },
          };
        void 0 !== t && t.exports ? (t.exports = n) : (e.Visibility = n);
      })(this);
    },
    function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = (function () {
        function t() {
          this._fullGroup = [
            "intro",
            // "kunal",
          ];
        }
        return (
          (t.prototype.getGroup = function (t) {
            var e = [],
              i = this._fullGroup,
              n = [];
            if (e.length < this._fullGroup.length) {
              var r = this._subGroup(e);
              r.length >= t
                ? (i = r)
                : ((n = r), (i = this._subGroup(r)), (t -= r.length));
            }
            for (; 0 < t-- && t < i.length; ) {
              var o = Math.floor(Math.random() * i.length);
              n = n.concat(i.splice(o, 1));
            }
            for (var s = 0; s < n.length; s++) n[s] = "#" + n[s];
            return n;
          }),
          (t.prototype._subGroup = function (t) {
            var e = this._fullGroup.slice(0);
            return (
              t.forEach(function (t) {
                var i = e.indexOf(t);
                -1 !== i && e.splice(i, 1);
              }),
              e
            );
          }),
          t
        );
      })();
      e.slidesManager = new n();
    },
  ]);
  
  